function getQuizResults(e) {
  let a = {
      Mythological: {
        Aphrodite: 0,
        Athena: 0,
        Freya: 0,
        Hecate: 0,
        Isis: 0,
        Lilith: 0,
        Medusa: 0,
        Persephone: 0,
        MotherEarth: 0,
        Selene: 0,
        Brigid: 0,
        TheMorrigan: 0,
        Bastet: 0,
        Guadalupe: 0,
        Asteria: 0,
        Psyche: 0,
        LadyBuddha: 0,
        Rhiannon: 0,
        Oshun: 0,
        Nemesis: 0,
        Hermaphroditus: 0,
        Fortuna: 0,
        Artemis: 0,
        Lakshmi: 0,
      },
      IRL: {
        JoanOfArc: 0,
        HarrietTubman: 0,
        Cleopatra: 0,
        Mulan: 0,
        FridaKahlo: 0,
        RBG: 0,
        FlorenceNightingale: 0,
        MotherMary: 0,
        Nefertiti: 0,
        MarshaPJohnson: 0,
        MarieCurie: 0,
        Sappho: 0,
      },
      AngelNumber: {
        111: 0,
        222: 0,
        333: 0,
        444: 0,
        555: 0,
        666: 0,
        777: 0,
        888: 0,
        999: 0,
      },
      Amulet: {
        GateOfHades: 2,
        WomanPower: 0,
        SpikedHeart: 1,
        OpalSun: 0,
        DiamondMoonWave: 0,
        TripleMoon: 0,
        DiamondSword: 0,
        CrescentSnakeEye: 0,
        MagicMushroom: 0,
        Pomegranate: 0,
        MagicalCat: 0,
        LuckyDragonfly: 0,
      },
      Aura: {
        Red: 0,
        Orange: 0,
        Yellow: 0,
        Green: 0,
        Blue: 0,
        Indigo: 0,
        Violet: 0,
      },
      Affirmations: {
        "Inhale the Future, Exhale the Past": 0,
        "Everything I need is Within Me": 0,
        "Say Yes to New Adventures": 0,
        "Purpose Over Perfect": 0,
        "I Am Worthy of Abundance": 0,
      },
      Elements: {
        "Aries: Mar 21 - Apr 19": 0,
        "Taurus: Apr 20 - May 20": 0,
        "Gemini: May 21 - June 21": 0,
        "Cancer: June 22 - July 22": 0,
        "Leo: July 23 - Aug 22": 0,
        "Virgo: Aug 23 - Sep 22": 0,
        "Libra: Sep 23 - Oct 23": 0,
        "Scorpio: Oct 24 - Nov 21": 0,
        "Sagittarius: Nov 22 - Dec 21": 0,
        "Capricorn: Dec 22 - Jan 19": 0,
        "Aquarius: Jan 20 - Feb 19": 0,
        "Pisces: Feb 19 - Mar 20": 0,
      },
      SunSign: {
        "Aries: Mar 21 - Apr 19": 0,
        "Taurus: Apr 20 - May 20": 0,
        "Gemini: May 21 - June 21": 0,
        "Cancer: June 22 - July 22": 0,
        "Leo: July 23 - Aug 22": 0,
        "Virgo: Aug 23 - Sep 22": 0,
        "Libra: Sep 23 - Oct 23": 0,
        "Scorpio: Oct 24 - Nov 21": 0,
        "Sagittarius: Nov 22 - Dec 21": 0,
        "Capricorn: Dec 22 - Jan 19": 0,
        "Aquarius: Jan 20 - Feb 19": 0,
        "Pisces: Feb 19 - Mar 20": 0,
      },
    },
    r = {
      Mythological: {
        octane_personal_style: {
          BOHO: {
            Aphrodite: 0,
            Athena: 0,
            Freya: 0,
            Hecate: 0,
            Isis: 0,
            Lilith: 0,
            Medusa: 0,
            Persephone: 1,
            MotherEarth: 1,
            Selene: 0,
            Brigid: 0,
            TheMorrigan: 0,
            Bastet: 0,
            Guadalupe: 0,
            Asteria: 0,
            Psyche: 0,
            LadyBuddha: 0,
            Rhiannon: 1,
            Oshun: 0,
            Nemesis: 0,
            Hermaphroditus: 0,
            Fortuna: 0,
            Artemis: 0,
            Lakshmi: 0,
          },
          ROMANTIC: {
            Aphrodite: 1,
            Athena: 0,
            Freya: 1,
            Hecate: -1,
            Isis: 0,
            Lilith: 0,
            Medusa: 0,
            Persephone: 1,
            MotherEarth: 0,
            Selene: 0,
            Brigid: 0,
            TheMorrigan: 0,
            Bastet: 0,
            Guadalupe: 0,
            Asteria: 0,
            Psyche: 0,
            LadyBuddha: 0,
            Rhiannon: 1,
            Oshun: 1,
            Nemesis: 0,
            Hermaphroditus: 1,
            Fortuna: 0,
            Artemis: 0,
            Lakshmi: 0,
          },
          CLASSIC: {
            Aphrodite: 0,
            Athena: 1,
            Freya: 0,
            Hecate: 0,
            Isis: 0,
            Lilith: -1,
            Medusa: -1,
            Persephone: 0,
            MotherEarth: 0,
            Selene: 1,
            Brigid: 0,
            TheMorrigan: 0,
            Bastet: 0,
            Guadalupe: 1,
            Asteria: 0,
            Psyche: 0,
            LadyBuddha: 0,
            Rhiannon: 0,
            Oshun: 0,
            Nemesis: 0,
            Hermaphroditus: -1,
            Fortuna: 1,
            Artemis: 1,
            Lakshmi: 0,
          },
          EDGY: {
            Aphrodite: 0,
            Athena: 0,
            Freya: 0,
            Hecate: 1,
            Isis: 0,
            Lilith: 1,
            Medusa: 1,
            Persephone: 1,
            MotherEarth: -1,
            Selene: -1,
            Brigid: 0,
            TheMorrigan: 1,
            Bastet: 0,
            Guadalupe: -1,
            Asteria: 0,
            Psyche: 0,
            LadyBuddha: 0,
            Rhiannon: 0,
            Oshun: -1,
            Nemesis: 1,
            Hermaphroditus: 0,
            Fortuna: 0,
            Artemis: 0,
            Lakshmi: 0,
          },
          GLAM: {
            Aphrodite: 0,
            Athena: -1,
            Freya: 1,
            Hecate: 0,
            Isis: 0,
            Lilith: 0,
            Medusa: 0,
            Persephone: 0,
            MotherEarth: 0,
            Selene: 0,
            Brigid: 0,
            TheMorrigan: -1,
            Bastet: 1,
            Guadalupe: 0,
            Asteria: 0,
            Psyche: 0,
            LadyBuddha: 0,
            Rhiannon: 0,
            Oshun: 0,
            Nemesis: 0,
            Hermaphroditus: 1,
            Fortuna: 0,
            Artemis: 0,
            Lakshmi: 0,
          },
        },
        octane_personal_description: {
          Introverted: {
            Aphrodite: 0,
            Athena: 0,
            Freya: -1,
            Hecate: 1,
            Isis: 0,
            Lilith: 1,
            Medusa: 1,
            Persephone: 0,
            MotherEarth: 0,
            Selene: 0,
            Brigid: 0,
            TheMorrigan: 1,
            Bastet: 0,
            Guadalupe: 0,
            Asteria: 0,
            Psyche: 0,
            LadyBuddha: 0,
            Rhiannon: 0,
            Oshun: 0,
            Nemesis: 0,
            Hermaphroditus: 0,
            Fortuna: 0,
            Artemis: 0,
            Lakshmi: 0,
          },
          "I love seeing my friends, but I prefer staying home": {
            Aphrodite: 0,
            Athena: 0,
            Freya: 0,
            Hecate: 1,
            Isis: 0,
            Lilith: 0,
            Medusa: 0,
            Persephone: 1,
            MotherEarth: 0,
            Selene: 0,
            Brigid: 0,
            TheMorrigan: 0,
            Bastet: 1,
            Guadalupe: 0,
            Asteria: 0,
            Psyche: 0,
            LadyBuddha: 0,
            Rhiannon: 0,
            Oshun: 0,
            Nemesis: 1,
            Hermaphroditus: 0,
            Fortuna: 0,
            Artemis: 1,
            Lakshmi: 0,
          },
          "Both - depends on the day": {
            Aphrodite: 0,
            Athena: 1,
            Freya: 0,
            Hecate: 0,
            Isis: 0,
            Lilith: 0,
            Medusa: 0,
            Persephone: 0,
            MotherEarth: 1,
            Selene: 1,
            Brigid: 0,
            TheMorrigan: 0,
            Bastet: 0,
            Guadalupe: 1,
            Asteria: 0,
            Psyche: 0,
            LadyBuddha: 0,
            Rhiannon: 0,
            Oshun: 0,
            Nemesis: 0,
            Hermaphroditus: 1,
            Fortuna: 0,
            Artemis: 0,
            Lakshmi: 0,
          },
          "Going out and making memories is so much fun": {
            Aphrodite: 1,
            Athena: 0,
            Freya: 0,
            Hecate: 0,
            Isis: 0,
            Lilith: 0,
            Medusa: 0,
            Persephone: 0,
            MotherEarth: 0,
            Selene: 0,
            Brigid: 0,
            TheMorrigan: 0,
            Bastet: 0,
            Guadalupe: 0,
            Asteria: 0,
            Psyche: 0,
            LadyBuddha: 0,
            Rhiannon: 0,
            Oshun: 1,
            Nemesis: 0,
            Hermaphroditus: 0,
            Fortuna: 1,
            Artemis: 0,
            Lakshmi: 0,
          },
          Extraverted: {
            Aphrodite: 0,
            Athena: 0,
            Freya: 1,
            Hecate: -1,
            Isis: 0,
            Lilith: 0,
            Medusa: -1,
            Persephone: 0,
            MotherEarth: 0,
            Selene: 0,
            Brigid: 0,
            TheMorrigan: -1,
            Bastet: 0,
            Guadalupe: 0,
            Asteria: 0,
            Psyche: 0,
            LadyBuddha: 0,
            Rhiannon: 1,
            Oshun: 0,
            Nemesis: 0,
            Hermaphroditus: 0,
            Fortuna: 0,
            Artemis: 0,
            Lakshmi: 1,
          },
        },
        octane_dream_home: {
          "A quiet country cottage": {
            Aphrodite: 0,
            Athena: 0,
            Freya: 0,
            Hecate: 0,
            Isis: 0,
            Lilith: 1,
            Medusa: 1,
            Persephone: 1,
            MotherEarth: 0,
            Selene: 0,
            Brigid: 0,
            TheMorrigan: 0,
            Bastet: 1,
            Guadalupe: 0,
            Asteria: 0,
            Psyche: 0,
            LadyBuddha: 0,
            Rhiannon: 1,
            Oshun: 0,
            Nemesis: 0,
            Hermaphroditus: 0,
            Fortuna: 0,
            Artemis: 0,
            Lakshmi: 0,
          },
          "An elegant high rise in the city": {
            Aphrodite: 0,
            Athena: 1,
            Freya: 0,
            Hecate: 0,
            Isis: 0,
            Lilith: 0,
            Medusa: 0,
            Persephone: 0,
            MotherEarth: 0,
            Selene: 0,
            Brigid: 0,
            TheMorrigan: 0,
            Bastet: 0,
            Guadalupe: 0,
            Asteria: 0,
            Psyche: 0,
            LadyBuddha: 0,
            Rhiannon: 0,
            Oshun: 0,
            Nemesis: 0,
            Hermaphroditus: 1,
            Fortuna: 0,
            Artemis: 0,
            Lakshmi: 0,
          },
          "A sprawling mansion with gorgeous gardens": {
            Aphrodite: 1,
            Athena: 0,
            Freya: 1,
            Hecate: 0,
            Isis: 0,
            Lilith: 0,
            Medusa: 0,
            Persephone: 0,
            MotherEarth: 0,
            Selene: 0,
            Brigid: 0,
            TheMorrigan: 0,
            Bastet: 1,
            Guadalupe: 1,
            Asteria: 0,
            Psyche: 0,
            LadyBuddha: 0,
            Rhiannon: 0,
            Oshun: 1,
            Nemesis: 0,
            Hermaphroditus: 0,
            Fortuna: 1,
            Artemis: 0,
            Lakshmi: 1,
          },
          "Mythical cabin at the edge of the woods": {
            Aphrodite: 0,
            Athena: 0,
            Freya: -1,
            Hecate: 1,
            Isis: 0,
            Lilith: 1,
            Medusa: 0,
            Persephone: 1,
            MotherEarth: -1,
            Selene: -1,
            Brigid: 0,
            TheMorrigan: 1,
            Bastet: 0,
            Guadalupe: 0,
            Asteria: 0,
            Psyche: 0,
            LadyBuddha: 0,
            Rhiannon: -1,
            Oshun: 0,
            Nemesis: 1,
            Hermaphroditus: 0,
            Fortuna: 0,
            Artemis: 0,
            Lakshmi: -1,
          },
          "A tropical bungalow under sunny blue skies": {
            Aphrodite: 0,
            Athena: 0,
            Freya: 0,
            Hecate: 0,
            Isis: 0,
            Lilith: -1,
            Medusa: -1,
            Persephone: 0,
            MotherEarth: 1,
            Selene: 1,
            Brigid: 0,
            TheMorrigan: -1,
            Bastet: 0,
            Guadalupe: 0,
            Asteria: 0,
            Psyche: 0,
            LadyBuddha: 0,
            Rhiannon: 0,
            Oshun: 0,
            Nemesis: 0,
            Hermaphroditus: 0,
            Fortuna: 0,
            Artemis: 1,
            Lakshmi: 0,
          },
        },
        octane_personal_charity: {
          "Gay, Lesbian, and Straight Education Network": {
            Aphrodite: 1,
            Athena: 0,
            Freya: 0,
            Hecate: 0,
            Isis: 0,
            Lilith: 1,
            Medusa: 0,
            Persephone: 0,
            MotherEarth: 0,
            Selene: 0,
            Brigid: 0,
            TheMorrigan: 0,
            Bastet: 1,
            Guadalupe: 0,
            Asteria: 0,
            Psyche: 0,
            LadyBuddha: 0,
            Rhiannon: 0,
            Oshun: 1,
            Nemesis: 0,
            Hermaphroditus: 1,
            Fortuna: 0,
            Artemis: 1,
            Lakshmi: 0,
          },
          "Women's Earth Alliance": {
            Aphrodite: 0,
            Athena: 0,
            Freya: 0,
            Hecate: 0,
            Isis: 0,
            Lilith: 0,
            Medusa: 0,
            Persephone: 1,
            MotherEarth: 1,
            Selene: 1,
            Brigid: 0,
            TheMorrigan: 0,
            Bastet: 0,
            Guadalupe: 0,
            Asteria: 0,
            Psyche: 0,
            LadyBuddha: 0,
            Rhiannon: 0,
            Oshun: 0,
            Nemesis: 0,
            Hermaphroditus: 0,
            Fortuna: 0,
            Artemis: 1,
            Lakshmi: 1,
          },
          "Rape, Abuse & Incest National Network": {
            Aphrodite: 0,
            Athena: 0,
            Freya: 0,
            Hecate: 0,
            Isis: 0,
            Lilith: 0,
            Medusa: 0,
            Persephone: 0,
            MotherEarth: 0,
            Selene: 0,
            Brigid: 0,
            TheMorrigan: 0,
            Bastet: 0,
            Guadalupe: 0,
            Asteria: 0,
            Psyche: 0,
            LadyBuddha: 0,
            Rhiannon: 0,
            Oshun: 0,
            Nemesis: 0,
            Hermaphroditus: 0,
            Fortuna: 0,
            Artemis: 0,
            Lakshmi: 0,
          },
          "The National Alliance on Mental Illness": {
            Aphrodite: 0,
            Athena: 0,
            Freya: 0,
            Hecate: 1,
            Isis: 0,
            Lilith: 0,
            Medusa: 1,
            Persephone: 0,
            MotherEarth: 0,
            Selene: 0,
            Brigid: 0,
            TheMorrigan: 1,
            Bastet: 0,
            Guadalupe: 0,
            Asteria: 0,
            Psyche: 1,
            LadyBuddha: 0,
            Rhiannon: 0,
            Oshun: 0,
            Nemesis: 0,
            Hermaphroditus: 0,
            Fortuna: 0,
            Artemis: 0,
            Lakshmi: 0,
          },
        },
        octane_personal_affirmation: {
          "Inhale the Future, Exhale the Past": {
            Aphrodite: 0,
            Athena: 0,
            Freya: 0,
            Hecate: 1,
            Isis: 0,
            Lilith: 1,
            Medusa: 1,
            Persephone: 0,
            MotherEarth: 0,
            Selene: 0,
            Brigid: 0,
            TheMorrigan: 1,
            Bastet: 0,
            Guadalupe: 0,
            Asteria: 1,
            Psyche: 0,
            LadyBuddha: 0,
            Rhiannon: 0,
            Oshun: 0,
            Nemesis: 0,
            Hermaphroditus: 0,
            Fortuna: 0,
            Artemis: 0,
            Lakshmi: 0,
          },
          "Everything I need is Within Me": {
            Aphrodite: 0,
            Athena: 1,
            Freya: 0,
            Hecate: 0,
            Isis: 0,
            Lilith: 0,
            Medusa: 0,
            Persephone: 1,
            MotherEarth: 0,
            Selene: 1,
            Brigid: 0,
            TheMorrigan: 0,
            Bastet: 0,
            Guadalupe: 1,
            Asteria: 0,
            Psyche: 1,
            LadyBuddha: 0,
            Rhiannon: 0,
            Oshun: 0,
            Nemesis: 0,
            Hermaphroditus: 1,
            Fortuna: 0,
            Artemis: 0,
            Lakshmi: 1,
          },
          "Say Yes to New Adventures": {
            Aphrodite: 1,
            Athena: 0,
            Freya: 1,
            Hecate: 0,
            Isis: 0,
            Lilith: 0,
            Medusa: 0,
            Persephone: 0,
            MotherEarth: 0,
            Selene: 0,
            Brigid: 0,
            TheMorrigan: 0,
            Bastet: 0,
            Guadalupe: 0,
            Asteria: 0,
            Psyche: 0,
            LadyBuddha: 0,
            Rhiannon: 1,
            Oshun: 0,
            Nemesis: 0,
            Hermaphroditus: 0,
            Fortuna: 1,
            Artemis: 1,
            Lakshmi: 0,
          },
          "Purpose Over Perfect": {
            Aphrodite: 0,
            Athena: 1,
            Freya: 0,
            Hecate: 1,
            Isis: 0,
            Lilith: 0,
            Medusa: 0,
            Persephone: 0,
            MotherEarth: 0,
            Selene: 0,
            Brigid: 0,
            TheMorrigan: 0,
            Bastet: 0,
            Guadalupe: 0,
            Asteria: 0,
            Psyche: 0,
            LadyBuddha: 0,
            Rhiannon: 0,
            Oshun: 0,
            Nemesis: 0,
            Hermaphroditus: 0,
            Fortuna: 0,
            Artemis: 0,
            Lakshmi: 0,
          },
          "I Am Worthy of Abundance": {
            Aphrodite: 1,
            Athena: 0,
            Freya: 1,
            Hecate: 0,
            Isis: 0,
            Lilith: 0,
            Medusa: 0,
            Persephone: 0,
            MotherEarth: 1,
            Selene: 0,
            Brigid: 0,
            TheMorrigan: 0,
            Bastet: 1,
            Guadalupe: 0,
            Asteria: 0,
            Psyche: 0,
            LadyBuddha: 0,
            Rhiannon: 0,
            Oshun: 1,
            Nemesis: 0,
            Hermaphroditus: 0,
            Fortuna: 0,
            Artemis: 0,
            Lakshmi: 1,
          },
        },
        octane_personal_need: {
          LOVE: {
            Aphrodite: 1,
            Athena: 0,
            Freya: 1,
            Hecate: -1,
            Isis: 0,
            Lilith: 0,
            Medusa: -1,
            Persephone: 0,
            MotherEarth: 0,
            Selene: 0,
            Brigid: 0,
            TheMorrigan: -1,
            Bastet: 0,
            Guadalupe: 0,
            Asteria: 0,
            Psyche: 0,
            LadyBuddha: 0,
            Rhiannon: 0,
            Oshun: 1,
            Nemesis: -1,
            Hermaphroditus: 1,
            Fortuna: 0,
            Artemis: -1,
            Lakshmi: 1,
          },
          "INNER PEACE": {
            Aphrodite: 0,
            Athena: 0,
            Freya: 0,
            Hecate: 0,
            Isis: 0,
            Lilith: 1,
            Medusa: 1,
            Persephone: 1,
            MotherEarth: 1,
            Selene: 1,
            Brigid: 0,
            TheMorrigan: 0,
            Bastet: 0,
            Guadalupe: 0,
            Asteria: 0,
            Psyche: 0,
            LadyBuddha: 0,
            Rhiannon: 1,
            Oshun: 0,
            Nemesis: 0,
            Hermaphroditus: 0,
            Fortuna: 1,
            Artemis: 0,
            Lakshmi: 0,
          },
          WISDOM: {
            Aphrodite: 0,
            Athena: 1,
            Freya: 0,
            Hecate: 0,
            Isis: 0,
            Lilith: 0,
            Medusa: 0,
            Persephone: 0,
            MotherEarth: 0,
            Selene: 0,
            Brigid: 0,
            TheMorrigan: 0,
            Bastet: 0,
            Guadalupe: 0,
            Asteria: 1,
            Psyche: 1,
            LadyBuddha: 0,
            Rhiannon: 0,
            Oshun: 0,
            Nemesis: 0,
            Hermaphroditus: 0,
            Fortuna: 0,
            Artemis: 0,
            Lakshmi: 1,
          },
          COURAGE: {
            Aphrodite: 0,
            Athena: 1,
            Freya: 0,
            Hecate: 0,
            Isis: 0,
            Lilith: 0,
            Medusa: 1,
            Persephone: 0,
            MotherEarth: 0,
            Selene: -1,
            Brigid: 0,
            TheMorrigan: 1,
            Bastet: 0,
            Guadalupe: 0,
            Asteria: 0,
            Psyche: 0,
            LadyBuddha: 0,
            Rhiannon: 0,
            Oshun: 0,
            Nemesis: 1,
            Hermaphroditus: 1,
            Fortuna: 0,
            Artemis: 1,
            Lakshmi: 0,
          },
          HEALTH: {
            Aphrodite: 0,
            Athena: 0,
            Freya: 0,
            Hecate: 0,
            Isis: 0,
            Lilith: 0,
            Medusa: 0,
            Persephone: 0,
            MotherEarth: 1,
            Selene: 0,
            Brigid: 0,
            TheMorrigan: 0,
            Bastet: 1,
            Guadalupe: 1,
            Asteria: 0,
            Psyche: 0,
            LadyBuddha: 0,
            Rhiannon: 0,
            Oshun: 0,
            Nemesis: 0,
            Hermaphroditus: 0,
            Fortuna: 0,
            Artemis: 0,
            Lakshmi: 1,
          },
        },
        octane_personal_animal: {
          Cat: {
            Aphrodite: 1,
            Athena: -1,
            Freya: 1,
            Hecate: 0,
            Isis: 0,
            Lilith: 0,
            Medusa: 0,
            Persephone: 0,
            MotherEarth: 0,
            Selene: 1,
            Brigid: 0,
            TheMorrigan: 0,
            Bastet: 1,
            Guadalupe: 0,
            Asteria: 0,
            Psyche: 0,
            LadyBuddha: 0,
            Rhiannon: 0,
            Oshun: 0,
            Nemesis: 0,
            Hermaphroditus: 0,
            Fortuna: 1,
            Artemis: 0,
            Lakshmi: 1,
          },
          Rabbit: {
            Aphrodite: 1,
            Athena: 0,
            Freya: 0,
            Hecate: 0,
            Isis: 0,
            Lilith: 0,
            Medusa: -1,
            Persephone: 0,
            MotherEarth: 1,
            Selene: 0,
            Brigid: 0,
            TheMorrigan: -1,
            Bastet: 0,
            Guadalupe: 1,
            Asteria: -1,
            Psyche: 0,
            LadyBuddha: 0,
            Rhiannon: 1,
            Oshun: 1,
            Nemesis: -1,
            Hermaphroditus: 0,
            Fortuna: 0,
            Artemis: 0,
            Lakshmi: 1,
          },
          Owl: {
            Aphrodite: 0,
            Athena: 1,
            Freya: 0,
            Hecate: 0,
            Isis: 0,
            Lilith: 0,
            Medusa: 0,
            Persephone: 0,
            MotherEarth: 0,
            Selene: 0,
            Brigid: 0,
            TheMorrigan: 0,
            Bastet: 0,
            Guadalupe: 0,
            Asteria: 0,
            Psyche: 1,
            LadyBuddha: 0,
            Rhiannon: 1,
            Oshun: 0,
            Nemesis: 0,
            Hermaphroditus: 0,
            Fortuna: 0,
            Artemis: 1,
            Lakshmi: 0,
          },
          Wolf: {
            Aphrodite: 0,
            Athena: 0,
            Freya: 0,
            Hecate: 1,
            Isis: 0,
            Lilith: 0,
            Medusa: 0,
            Persephone: 1,
            MotherEarth: 0,
            Selene: 0,
            Brigid: 0,
            TheMorrigan: 1,
            Bastet: 0,
            Guadalupe: 0,
            Asteria: 0,
            Psyche: 0,
            LadyBuddha: 0,
            Rhiannon: 0,
            Oshun: 0,
            Nemesis: 1,
            Hermaphroditus: -1,
            Fortuna: -1,
            Artemis: 1,
            Lakshmi: 0,
          },
          Snake: {
            Aphrodite: -1,
            Athena: 0,
            Freya: -1,
            Hecate: 1,
            Isis: 0,
            Lilith: 1,
            Medusa: 1,
            Persephone: 0,
            MotherEarth: 0,
            Selene: 0,
            Brigid: 0,
            TheMorrigan: 1,
            Bastet: 0,
            Guadalupe: 0,
            Asteria: 1,
            Psyche: 0,
            LadyBuddha: 0,
            Rhiannon: 0,
            Oshun: -1,
            Nemesis: 0,
            Hermaphroditus: 1,
            Fortuna: 0,
            Artemis: 0,
            Lakshmi: -1,
          },
        },
        octane_personal_die: {
          "We go to heaven... or hell": {
            Aphrodite: 1,
            Athena: 1,
            Freya: 1,
            Hecate: 0,
            Isis: 0,
            Lilith: 0,
            Medusa: 0,
            Persephone: 1,
            MotherEarth: 0,
            Selene: 0,
            Brigid: 0,
            TheMorrigan: 0,
            Bastet: 0,
            Guadalupe: 1,
            Asteria: 0,
            Psyche: 0,
            LadyBuddha: 0,
            Rhiannon: 0,
            Oshun: 0,
            Nemesis: 0,
            Hermaphroditus: 0,
            Fortuna: 1,
            Artemis: 0,
            Lakshmi: 0,
          },
          "We're reincarnated": {
            Aphrodite: 0,
            Athena: 0,
            Freya: 0,
            Hecate: 0,
            Isis: 0,
            Lilith: 0,
            Medusa: 0,
            Persephone: 0,
            MotherEarth: 0,
            Selene: 0,
            Brigid: 0,
            TheMorrigan: 0,
            Bastet: 1,
            Guadalupe: 0,
            Asteria: 0,
            Psyche: 0,
            LadyBuddha: 0,
            Rhiannon: 1,
            Oshun: 0,
            Nemesis: 0,
            Hermaphroditus: 1,
            Fortuna: 0,
            Artemis: 0,
            Lakshmi: 1,
          },
          "Our energy is dispersed in the universe": {
            Aphrodite: 0,
            Athena: 0,
            Freya: 0,
            Hecate: 0,
            Isis: 0,
            Lilith: 0,
            Medusa: 0,
            Persephone: 0,
            MotherEarth: 1,
            Selene: 1,
            Brigid: 0,
            TheMorrigan: 1,
            Bastet: 0,
            Guadalupe: 0,
            Asteria: 1,
            Psyche: 0,
            LadyBuddha: 0,
            Rhiannon: 1,
            Oshun: 0,
            Nemesis: 0,
            Hermaphroditus: 1,
            Fortuna: 0,
            Artemis: 0,
            Lakshmi: 1,
          },
          "We simply cease to exist": {
            Aphrodite: 0,
            Athena: 1,
            Freya: 0,
            Hecate: 0,
            Isis: 0,
            Lilith: 0,
            Medusa: 0,
            Persephone: 0,
            MotherEarth: 0,
            Selene: 0,
            Brigid: 0,
            TheMorrigan: 0,
            Bastet: 0,
            Guadalupe: 0,
            Asteria: 0,
            Psyche: 1,
            LadyBuddha: 0,
            Rhiannon: 0,
            Oshun: 0,
            Nemesis: 0,
            Hermaphroditus: 0,
            Fortuna: 0,
            Artemis: 0,
            Lakshmi: 0,
          },
          "We haunt our enemies, that's what": {
            Aphrodite: -1,
            Athena: 0,
            Freya: 0,
            Hecate: 1,
            Isis: 0,
            Lilith: 1,
            Medusa: 1,
            Persephone: 0,
            MotherEarth: -1,
            Selene: -1,
            Brigid: 0,
            TheMorrigan: 1,
            Bastet: 0,
            Guadalupe: -1,
            Asteria: 0,
            Psyche: 0,
            LadyBuddha: -1,
            Rhiannon: 0,
            Oshun: -1,
            Nemesis: 1,
            Hermaphroditus: 0,
            Fortuna: -1,
            Artemis: 0,
            Lakshmi: -1,
          },
        },
        octane_personal_wrongs_me: {
          "Ignore it. Karma will take care of them": {
            Aphrodite: 0,
            Athena: 1,
            Freya: 0,
            Hecate: 0,
            Isis: 0,
            Lilith: 0,
            Medusa: -1,
            Persephone: 0,
            MotherEarth: 1,
            Selene: 0,
            Brigid: 0,
            TheMorrigan: 0,
            Bastet: 1,
            Guadalupe: 0,
            Asteria: 1,
            Psyche: 0,
            LadyBuddha: 1,
            Rhiannon: 0,
            Oshun: 0,
            Nemesis: 0,
            Hermaphroditus: 1,
            Fortuna: 1,
            Artemis: 1,
            Lakshmi: 0,
          },
          "Express my feelings. Even if it isn't solved, I will feel better": {
            Aphrodite: 1,
            Athena: 0,
            Freya: 1,
            Hecate: 0,
            Isis: 0,
            Lilith: 0,
            Medusa: 0,
            Persephone: 1,
            MotherEarth: 1,
            Selene: 0,
            Brigid: 0,
            TheMorrigan: 1,
            Bastet: 1,
            Guadalupe: 0,
            Asteria: 1,
            Psyche: 1,
            LadyBuddha: -1,
            Rhiannon: 1,
            Oshun: 0,
            Nemesis: 0,
            Hermaphroditus: 0,
            Fortuna: 0,
            Artemis: 1,
            Lakshmi: 1,
          },
          "Confront them. I deserve explanation and resolution": {
            Aphrodite: 0,
            Athena: 0,
            Freya: 0,
            Hecate: 1,
            Isis: 0,
            Lilith: 1,
            Medusa: 1,
            Persephone: 1,
            MotherEarth: -1,
            Selene: 0,
            Brigid: 0,
            TheMorrigan: 1,
            Bastet: 0,
            Guadalupe: -1,
            Asteria: 0,
            Psyche: 0,
            LadyBuddha: -1,
            Rhiannon: 0,
            Oshun: 0,
            Nemesis: 1,
            Hermaphroditus: 0,
            Fortuna: 0,
            Artemis: 0,
            Lakshmi: 1,
          },
        },
        octane_personal_admire: {
          "Creative & Unique": {
            Aphrodite: 0,
            Athena: 0,
            Freya: 0,
            Hecate: 0,
            Isis: 0,
            Lilith: 0,
            Medusa: 0,
            Persephone: 0,
            MotherEarth: 1,
            Selene: 0,
            Brigid: 0,
            TheMorrigan: 0,
            Bastet: 0,
            Guadalupe: 0,
            Asteria: 0,
            Psyche: 0,
            LadyBuddha: 0,
            Rhiannon: 1,
            Oshun: 0,
            Nemesis: 0,
            Hermaphroditus: 1,
            Fortuna: 0,
            Artemis: 0,
            Lakshmi: 0,
          },
          "Wise & Eloquent": {
            Aphrodite: 0,
            Athena: 1,
            Freya: 0,
            Hecate: 0,
            Isis: 0,
            Lilith: 0,
            Medusa: 0,
            Persephone: 0,
            MotherEarth: 0,
            Selene: 0,
            Brigid: 0,
            TheMorrigan: 0,
            Bastet: 0,
            Guadalupe: 1,
            Asteria: 1,
            Psyche: 1,
            LadyBuddha: 1,
            Rhiannon: 0,
            Oshun: 0,
            Nemesis: 0,
            Hermaphroditus: 0,
            Fortuna: 1,
            Artemis: 0,
            Lakshmi: 0,
          },
          "Enigmatic & Charming": {
            Aphrodite: 1,
            Athena: 0,
            Freya: 1,
            Hecate: 1,
            Isis: 0,
            Lilith: 1,
            Medusa: 0,
            Persephone: 1,
            MotherEarth: 0,
            Selene: 1,
            Brigid: 0,
            TheMorrigan: 0,
            Bastet: 1,
            Guadalupe: 0,
            Asteria: 0,
            Psyche: 1,
            LadyBuddha: 0,
            Rhiannon: 0,
            Oshun: 1,
            Nemesis: 0,
            Hermaphroditus: 0,
            Fortuna: 0,
            Artemis: 0,
            Lakshmi: 0,
          },
          "Persistent & Hardworking": {
            Aphrodite: -1,
            Athena: 1,
            Freya: 0,
            Hecate: 0,
            Isis: 0,
            Lilith: 0,
            Medusa: 1,
            Persephone: 0,
            MotherEarth: 0,
            Selene: 0,
            Brigid: 0,
            TheMorrigan: 0,
            Bastet: 0,
            Guadalupe: 0,
            Asteria: 0,
            Psyche: 0,
            LadyBuddha: 0,
            Rhiannon: 0,
            Oshun: 1,
            Nemesis: 0,
            Hermaphroditus: 1,
            Fortuna: 1,
            Artemis: 1,
            Lakshmi: 0,
          },
        },
        octane_personal_zodiac: {
          "Aries: Mar 21 - Apr 19": {
            Aphrodite: 0,
            Athena: 0,
            Freya: 0,
            Hecate: 0,
            Isis: 0,
            Lilith: 0,
            Medusa: 0,
            Persephone: 0,
            MotherEarth: 0,
            Selene: 0,
            Brigid: 0,
            TheMorrigan: 0,
            Bastet: 0,
            Guadalupe: 0,
            Asteria: 0,
            Psyche: 0,
            LadyBuddha: 0,
            Rhiannon: 0,
            Oshun: 0,
            Nemesis: 0,
            Hermaphroditus: 0,
            Fortuna: 0,
            Artemis: 0,
            Lakshmi: 0,
          },
          "Taurus: Apr 20 - May 20": {
            Aphrodite: 0,
            Athena: 0,
            Freya: 0,
            Hecate: 0,
            Isis: 0,
            Lilith: 0,
            Medusa: 0,
            Persephone: 0,
            MotherEarth: 0,
            Selene: 0,
            Brigid: 0,
            TheMorrigan: 0,
            Bastet: 0,
            Guadalupe: 0,
            Asteria: 0,
            Psyche: 0,
            LadyBuddha: 0,
            Rhiannon: 0,
            Oshun: 0,
            Nemesis: 0,
            Hermaphroditus: 0,
            Fortuna: 0,
            Artemis: 0,
            Lakshmi: 0,
          },
          "Gemini: May 21 - June 21": {
            Aphrodite: 0,
            Athena: 0,
            Freya: 0,
            Hecate: 0,
            Isis: 0,
            Lilith: 0,
            Medusa: 0,
            Persephone: 0,
            MotherEarth: 0,
            Selene: 0,
            Brigid: 0,
            TheMorrigan: 0,
            Bastet: 0,
            Guadalupe: 0,
            Asteria: 0,
            Psyche: 0,
            LadyBuddha: 0,
            Rhiannon: 0,
            Oshun: 0,
            Nemesis: 0,
            Hermaphroditus: 0,
            Fortuna: 0,
            Artemis: 0,
            Lakshmi: 0,
          },
          "Cancer: June 22 - July 22": {
            Aphrodite: 0,
            Athena: 0,
            Freya: 0,
            Hecate: 0,
            Isis: 0,
            Lilith: 0,
            Medusa: 0,
            Persephone: 0,
            MotherEarth: 0,
            Selene: 0,
            Brigid: 0,
            TheMorrigan: 0,
            Bastet: 0,
            Guadalupe: 0,
            Asteria: 0,
            Psyche: 0,
            LadyBuddha: 0,
            Rhiannon: 0,
            Oshun: 0,
            Nemesis: 0,
            Hermaphroditus: 0,
            Fortuna: 0,
            Artemis: 0,
            Lakshmi: 0,
          },
          "Leo: July 23 - Aug 22": {
            Aphrodite: 0,
            Athena: 0,
            Freya: 0,
            Hecate: 0,
            Isis: 0,
            Lilith: 0,
            Medusa: 0,
            Persephone: 0,
            MotherEarth: 0,
            Selene: 0,
            Brigid: 0,
            TheMorrigan: 0,
            Bastet: 0,
            Guadalupe: 0,
            Asteria: 0,
            Psyche: 0,
            LadyBuddha: 0,
            Rhiannon: 0,
            Oshun: 0,
            Nemesis: 0,
            Hermaphroditus: 0,
            Fortuna: 0,
            Artemis: 0,
            Lakshmi: 0,
          },
          "Virgo: Aug 23 - Sep 22": {
            Aphrodite: 0,
            Athena: 0,
            Freya: 0,
            Hecate: 0,
            Isis: 0,
            Lilith: 0,
            Medusa: 0,
            Persephone: 0,
            MotherEarth: 0,
            Selene: 0,
            Brigid: 0,
            TheMorrigan: 0,
            Bastet: 0,
            Guadalupe: 0,
            Asteria: 0,
            Psyche: 0,
            LadyBuddha: 0,
            Rhiannon: 0,
            Oshun: 0,
            Nemesis: 0,
            Hermaphroditus: 0,
            Fortuna: 0,
            Artemis: 0,
            Lakshmi: 0,
          },
          "Libra: Sep 23 - Oct 23": {
            Aphrodite: 0,
            Athena: 0,
            Freya: 0,
            Hecate: 0,
            Isis: 0,
            Lilith: 0,
            Medusa: 0,
            Persephone: 0,
            MotherEarth: 0,
            Selene: 0,
            Brigid: 0,
            TheMorrigan: 0,
            Bastet: 0,
            Guadalupe: 0,
            Asteria: 0,
            Psyche: 0,
            LadyBuddha: 0,
            Rhiannon: 0,
            Oshun: 0,
            Nemesis: 0,
            Hermaphroditus: 0,
            Fortuna: 0,
            Artemis: 0,
            Lakshmi: 0,
          },
          "Scorpio: Oct 24 - Nov 21": {
            Aphrodite: 0,
            Athena: 0,
            Freya: 0,
            Hecate: 0,
            Isis: 0,
            Lilith: 0,
            Medusa: 0,
            Persephone: 0,
            MotherEarth: 0,
            Selene: 0,
            Brigid: 0,
            TheMorrigan: 0,
            Bastet: 0,
            Guadalupe: 0,
            Asteria: 0,
            Psyche: 0,
            LadyBuddha: 0,
            Rhiannon: 0,
            Oshun: 0,
            Nemesis: 0,
            Hermaphroditus: 0,
            Fortuna: 0,
            Artemis: 0,
            Lakshmi: 0,
          },
          "Sagittarius: Nov 22 - Dec 21": {
            Aphrodite: 0,
            Athena: 0,
            Freya: 0,
            Hecate: 0,
            Isis: 0,
            Lilith: 0,
            Medusa: 0,
            Persephone: 0,
            MotherEarth: 0,
            Selene: 0,
            Brigid: 0,
            TheMorrigan: 0,
            Bastet: 0,
            Guadalupe: 0,
            Asteria: 0,
            Psyche: 0,
            LadyBuddha: 0,
            Rhiannon: 0,
            Oshun: 0,
            Nemesis: 0,
            Hermaphroditus: 0,
            Fortuna: 0,
            Artemis: 0,
            Lakshmi: 0,
          },
          "Capricorn: Dec 22 - Jan 19": {
            Aphrodite: 0,
            Athena: 0,
            Freya: 0,
            Hecate: 0,
            Isis: 0,
            Lilith: 0,
            Medusa: 0,
            Persephone: 0,
            MotherEarth: 0,
            Selene: 0,
            Brigid: 0,
            TheMorrigan: 0,
            Bastet: 0,
            Guadalupe: 0,
            Asteria: 0,
            Psyche: 0,
            LadyBuddha: 0,
            Rhiannon: 0,
            Oshun: 0,
            Nemesis: 0,
            Hermaphroditus: 0,
            Fortuna: 0,
            Artemis: 0,
            Lakshmi: 0,
          },
          "Aquarius: Jan 20 - Feb 19": {
            Aphrodite: 0,
            Athena: 0,
            Freya: 0,
            Hecate: 0,
            Isis: 0,
            Lilith: 0,
            Medusa: 0,
            Persephone: 0,
            MotherEarth: 0,
            Selene: 0,
            Brigid: 0,
            TheMorrigan: 0,
            Bastet: 0,
            Guadalupe: 0,
            Asteria: 0,
            Psyche: 0,
            LadyBuddha: 0,
            Rhiannon: 0,
            Oshun: 0,
            Nemesis: 0,
            Hermaphroditus: 0,
            Fortuna: 0,
            Artemis: 0,
            Lakshmi: 0,
          },
          "Pisces: Feb 19 - Mar 20": {
            Aphrodite: 0,
            Athena: 0,
            Freya: 0,
            Hecate: 0,
            Isis: 0,
            Lilith: 0,
            Medusa: 0,
            Persephone: 0,
            MotherEarth: 0,
            Selene: 0,
            Brigid: 0,
            TheMorrigan: 0,
            Bastet: 0,
            Guadalupe: 0,
            Asteria: 0,
            Psyche: 0,
            LadyBuddha: 0,
            Rhiannon: 0,
            Oshun: 0,
            Nemesis: 0,
            Hermaphroditus: 0,
            Fortuna: 0,
            Artemis: 0,
            Lakshmi: 0,
          },
        },
      },
      IRL: {
        octane_personal_style: {
          BOHO: {
            JoanOfArc: 0,
            HarrietTubman: 0,
            Cleopatra: 0,
            Mulan: 0,
            FridaKahlo: 0,
            RBG: -1,
            FlorenceNightingale: 0,
            MotherMary: 0,
            Nefertiti: 0,
            MarshaPJohnson: 0,
            MarieCurie: -1,
            Sappho: 0,
          },
          ROMANTIC: {
            JoanOfArc: 0,
            HarrietTubman: 0,
            Cleopatra: 0,
            Mulan: -1,
            FridaKahlo: 0,
            RBG: 0,
            FlorenceNightingale: 0,
            MotherMary: 1,
            Nefertiti: 0,
            MarshaPJohnson: 1,
            MarieCurie: 0,
            Sappho: 1,
          },
          CLASSIC: {
            JoanOfArc: 0,
            HarrietTubman: 1,
            Cleopatra: 0,
            Mulan: 1,
            FridaKahlo: 0,
            RBG: 1,
            FlorenceNightingale: 1,
            MotherMary: 0,
            Nefertiti: 0,
            MarshaPJohnson: 0,
            MarieCurie: 1,
            Sappho: 0,
          },
          EDGY: {
            JoanOfArc: 0,
            HarrietTubman: 0,
            Cleopatra: -1,
            Mulan: 0,
            FridaKahlo: 0,
            RBG: -1,
            FlorenceNightingale: -1,
            MotherMary: -1,
            Nefertiti: 0,
            MarshaPJohnson: 0,
            MarieCurie: 0,
            Sappho: -1,
          },
          GLAM: {
            JoanOfArc: 0,
            HarrietTubman: 0,
            Cleopatra: 1,
            Mulan: 0,
            FridaKahlo: 0,
            RBG: 0,
            FlorenceNightingale: 0,
            MotherMary: -1,
            Nefertiti: 0,
            MarshaPJohnson: 1,
            MarieCurie: 0,
            Sappho: 0,
          },
        },
        octane_personal_description: {
          Introverted: {
            JoanOfArc: 0,
            HarrietTubman: 0,
            Cleopatra: 0,
            Mulan: 0,
            FridaKahlo: 0,
            RBG: 0,
            FlorenceNightingale: 0,
            MotherMary: 0,
            Nefertiti: 0,
            MarshaPJohnson: -1,
            MarieCurie: 0,
            Sappho: 0,
          },
          "I love seeing my friends, but I prefer staying home": {
            JoanOfArc: 0,
            HarrietTubman: 0,
            Cleopatra: 0,
            Mulan: 1,
            FridaKahlo: 0,
            RBG: 0,
            FlorenceNightingale: 0,
            MotherMary: 1,
            Nefertiti: 0,
            MarshaPJohnson: 0,
            MarieCurie: 1,
            Sappho: 1,
          },
          "Both - depends on the day": {
            JoanOfArc: 0,
            HarrietTubman: 0,
            Cleopatra: 0,
            Mulan: 0,
            FridaKahlo: 0,
            RBG: 0,
            FlorenceNightingale: 1,
            MotherMary: 0,
            Nefertiti: 0,
            MarshaPJohnson: 0,
            MarieCurie: 0,
            Sappho: 0,
          },
          "Going out and making memories is so much fun": {
            JoanOfArc: 0,
            HarrietTubman: 1,
            Cleopatra: 0,
            Mulan: 0,
            FridaKahlo: 0,
            RBG: 1,
            FlorenceNightingale: 0,
            MotherMary: 0,
            Nefertiti: 0,
            MarshaPJohnson: 0,
            MarieCurie: 0,
            Sappho: 0,
          },
          Extraverted: {
            JoanOfArc: 0,
            HarrietTubman: 0,
            Cleopatra: 1,
            Mulan: 0,
            FridaKahlo: 0,
            RBG: 0,
            FlorenceNightingale: 0,
            MotherMary: 0,
            Nefertiti: 0,
            MarshaPJohnson: 1,
            MarieCurie: -1,
            Sappho: 0,
          },
        },
        octane_dream_home: {
          "A quiet country cottage": {
            JoanOfArc: 0,
            HarrietTubman: 1,
            Cleopatra: 0,
            Mulan: 0,
            FridaKahlo: 0,
            RBG: 0,
            FlorenceNightingale: 0,
            MotherMary: 1,
            Nefertiti: 0,
            MarshaPJohnson: 0,
            MarieCurie: 0,
            Sappho: 0,
          },
          "An elegant high rise in the city": {
            JoanOfArc: 0,
            HarrietTubman: 0,
            Cleopatra: 0,
            Mulan: 0,
            FridaKahlo: 0,
            RBG: 1,
            FlorenceNightingale: 0,
            MotherMary: 0,
            Nefertiti: 0,
            MarshaPJohnson: 0,
            MarieCurie: 1,
            Sappho: 0,
          },
          "A sprawling mansion with gorgeous gardens": {
            JoanOfArc: 0,
            HarrietTubman: 0,
            Cleopatra: 1,
            Mulan: 0,
            FridaKahlo: 0,
            RBG: 0,
            FlorenceNightingale: 1,
            MotherMary: 0,
            Nefertiti: 0,
            MarshaPJohnson: 0,
            MarieCurie: 0,
            Sappho: 0,
          },
          "Mythical cabin at the edge of the woods": {
            JoanOfArc: 0,
            HarrietTubman: 0,
            Cleopatra: -1,
            Mulan: 0,
            FridaKahlo: 0,
            RBG: 0,
            FlorenceNightingale: -1,
            MotherMary: 0,
            Nefertiti: 0,
            MarshaPJohnson: 0,
            MarieCurie: 0,
            Sappho: 0,
          },
          "A tropical bungalow under sunny blue skies": {
            JoanOfArc: 0,
            HarrietTubman: 0,
            Cleopatra: 0,
            Mulan: 1,
            FridaKahlo: 0,
            RBG: 0,
            FlorenceNightingale: 0,
            MotherMary: 0,
            Nefertiti: 0,
            MarshaPJohnson: 1,
            MarieCurie: 0,
            Sappho: 1,
          },
        },
        octane_personal_charity: {
          "Gay, Lesbian, and Straight Education Network": {
            JoanOfArc: 0,
            HarrietTubman: 0,
            Cleopatra: 0,
            Mulan: 0,
            FridaKahlo: 0,
            RBG: 0,
            FlorenceNightingale: 0,
            MotherMary: 0,
            Nefertiti: 0,
            MarshaPJohnson: 0,
            MarieCurie: 0,
            Sappho: 0,
          },
          "Women's Earth Alliance": {
            JoanOfArc: 0,
            HarrietTubman: 0,
            Cleopatra: 0,
            Mulan: 0,
            FridaKahlo: 0,
            RBG: 0,
            FlorenceNightingale: 0,
            MotherMary: 0,
            Nefertiti: 0,
            MarshaPJohnson: 0,
            MarieCurie: 0,
            Sappho: 0,
          },
          "Rape, Abuse & Incest National Network": {
            JoanOfArc: 0,
            HarrietTubman: 0,
            Cleopatra: 0,
            Mulan: 0,
            FridaKahlo: 0,
            RBG: 0,
            FlorenceNightingale: 0,
            MotherMary: 0,
            Nefertiti: 0,
            MarshaPJohnson: 0,
            MarieCurie: 0,
            Sappho: 0,
          },
          "The National Alliance on Mental Illness": {
            JoanOfArc: 0,
            HarrietTubman: 0,
            Cleopatra: 0,
            Mulan: 0,
            FridaKahlo: 0,
            RBG: 0,
            FlorenceNightingale: 0,
            MotherMary: 0,
            Nefertiti: 0,
            MarshaPJohnson: 0,
            MarieCurie: 0,
            Sappho: 0,
          },
        },
        octane_personal_affirmation: {
          "Inhale the Future, Exhale the Past": {
            JoanOfArc: 0,
            HarrietTubman: 1,
            Cleopatra: 0,
            Mulan: 0,
            FridaKahlo: 0,
            RBG: 0,
            FlorenceNightingale: 0,
            MotherMary: 0,
            Nefertiti: 0,
            MarshaPJohnson: 1,
            MarieCurie: 0,
            Sappho: 0,
          },
          "Everything I need is Within Me": {
            JoanOfArc: 0,
            HarrietTubman: 0,
            Cleopatra: 0,
            Mulan: 0,
            FridaKahlo: 0,
            RBG: 0,
            FlorenceNightingale: 1,
            MotherMary: 0,
            Nefertiti: 0,
            MarshaPJohnson: 0,
            MarieCurie: 0,
            Sappho: 1,
          },
          "Say Yes to New Adventures": {
            JoanOfArc: 0,
            HarrietTubman: 0,
            Cleopatra: 0,
            Mulan: 1,
            FridaKahlo: 0,
            RBG: 0,
            FlorenceNightingale: 0,
            MotherMary: 0,
            Nefertiti: 0,
            MarshaPJohnson: 0,
            MarieCurie: 0,
            Sappho: 0,
          },
          "Purpose Over Perfect": {
            JoanOfArc: 0,
            HarrietTubman: 0,
            Cleopatra: 0,
            Mulan: 0,
            FridaKahlo: 0,
            RBG: 1,
            FlorenceNightingale: 0,
            MotherMary: 1,
            Nefertiti: 0,
            MarshaPJohnson: 0,
            MarieCurie: 1,
            Sappho: 0,
          },
          "I Am Worthy of Abundance": {
            JoanOfArc: 0,
            HarrietTubman: 0,
            Cleopatra: 1,
            Mulan: 0,
            FridaKahlo: 0,
            RBG: 0,
            FlorenceNightingale: 0,
            MotherMary: 0,
            Nefertiti: 0,
            MarshaPJohnson: 0,
            MarieCurie: 0,
            Sappho: 0,
          },
        },
        octane_personal_need: {
          LOVE: {
            JoanOfArc: 0,
            HarrietTubman: 0,
            Cleopatra: 1,
            Mulan: -1,
            FridaKahlo: 0,
            RBG: 0,
            FlorenceNightingale: 0,
            MotherMary: 1,
            Nefertiti: 0,
            MarshaPJohnson: 1,
            MarieCurie: 0,
            Sappho: 1,
          },
          "INNER PEACE": {
            JoanOfArc: 0,
            HarrietTubman: 0,
            Cleopatra: -1,
            Mulan: 0,
            FridaKahlo: 0,
            RBG: 0,
            FlorenceNightingale: 0,
            MotherMary: 1,
            Nefertiti: 0,
            MarshaPJohnson: 0,
            MarieCurie: 0,
            Sappho: 0,
          },
          WISDOM: {
            JoanOfArc: 0,
            HarrietTubman: 0,
            Cleopatra: 0,
            Mulan: 0,
            FridaKahlo: 0,
            RBG: 1,
            FlorenceNightingale: 0,
            MotherMary: 0,
            Nefertiti: 0,
            MarshaPJohnson: 0,
            MarieCurie: 1,
            Sappho: 0,
          },
          COURAGE: {
            JoanOfArc: 0,
            HarrietTubman: 1,
            Cleopatra: 1,
            Mulan: 1,
            FridaKahlo: 0,
            RBG: 0,
            FlorenceNightingale: 1,
            MotherMary: 0,
            Nefertiti: 0,
            MarshaPJohnson: 0,
            MarieCurie: 0,
            Sappho: 0,
          },
          HEALTH: {
            JoanOfArc: 0,
            HarrietTubman: 0,
            Cleopatra: 0,
            Mulan: 0,
            FridaKahlo: 0,
            RBG: 0,
            FlorenceNightingale: 1,
            MotherMary: 1,
            Nefertiti: 0,
            MarshaPJohnson: 0,
            MarieCurie: 0,
            Sappho: 0,
          },
        },
        octane_personal_animal: {
          Cat: {
            JoanOfArc: 0,
            HarrietTubman: -1,
            Cleopatra: 1,
            Mulan: -1,
            FridaKahlo: 0,
            RBG: -1,
            FlorenceNightingale: 0,
            MotherMary: 0,
            Nefertiti: 0,
            MarshaPJohnson: 0,
            MarieCurie: -1,
            Sappho: 0,
          },
          Rabbit: {
            JoanOfArc: 0,
            HarrietTubman: 0,
            Cleopatra: 0,
            Mulan: 0,
            FridaKahlo: 0,
            RBG: 0,
            FlorenceNightingale: 1,
            MotherMary: 1,
            Nefertiti: 0,
            MarshaPJohnson: 0,
            MarieCurie: 0,
            Sappho: 0,
          },
          Owl: {
            JoanOfArc: 0,
            HarrietTubman: 1,
            Cleopatra: 0,
            Mulan: 0,
            FridaKahlo: 0,
            RBG: 1,
            FlorenceNightingale: 0,
            MotherMary: 0,
            Nefertiti: 0,
            MarshaPJohnson: 0,
            MarieCurie: 1,
            Sappho: 0,
          },
          Wolf: {
            JoanOfArc: 0,
            HarrietTubman: 0,
            Cleopatra: 0,
            Mulan: 1,
            FridaKahlo: 0,
            RBG: 0,
            FlorenceNightingale: 0,
            MotherMary: 0,
            Nefertiti: 0,
            MarshaPJohnson: 0,
            MarieCurie: 0,
            Sappho: 0,
          },
          Snake: {
            JoanOfArc: 0,
            HarrietTubman: 0,
            Cleopatra: 0,
            Mulan: 0,
            FridaKahlo: 0,
            RBG: 0,
            FlorenceNightingale: 0,
            MotherMary: -1,
            Nefertiti: 0,
            MarshaPJohnson: 1,
            MarieCurie: 0,
            Sappho: -1,
          },
        },
        octane_personal_die: {
          "We go to heaven... or hell": {
            JoanOfArc: 0,
            HarrietTubman: 1,
            Cleopatra: 0,
            Mulan: 0,
            FridaKahlo: 0,
            RBG: 0,
            FlorenceNightingale: 1,
            MotherMary: 1,
            Nefertiti: 0,
            MarshaPJohnson: 0,
            MarieCurie: 0,
            Sappho: 0,
          },
          "We're reincarnated": {
            JoanOfArc: 0,
            HarrietTubman: 0,
            Cleopatra: 1,
            Mulan: 0,
            FridaKahlo: 0,
            RBG: 0,
            FlorenceNightingale: 0,
            MotherMary: 0,
            Nefertiti: 0,
            MarshaPJohnson: 0,
            MarieCurie: 0,
            Sappho: 0,
          },
          "Our energy is dispersed in the universe": {
            JoanOfArc: 0,
            HarrietTubman: 0,
            Cleopatra: 0,
            Mulan: 0,
            FridaKahlo: 0,
            RBG: 0,
            FlorenceNightingale: 0,
            MotherMary: 0,
            Nefertiti: 0,
            MarshaPJohnson: 1,
            MarieCurie: 0,
            Sappho: 1,
          },
          "We simply cease to exist": {
            JoanOfArc: 0,
            HarrietTubman: 0,
            Cleopatra: 0,
            Mulan: 1,
            FridaKahlo: 0,
            RBG: 1,
            FlorenceNightingale: 0,
            MotherMary: 0,
            Nefertiti: 0,
            MarshaPJohnson: 1,
            MarieCurie: 0,
            Sappho: 0,
          },
          "We haunt our enemies, that's what": {
            JoanOfArc: 0,
            HarrietTubman: -1,
            Cleopatra: 0,
            Mulan: 0,
            FridaKahlo: 0,
            RBG: 1,
            FlorenceNightingale: 0,
            MotherMary: 0,
            Nefertiti: 0,
            MarshaPJohnson: 0,
            MarieCurie: 0,
            Sappho: 0,
          },
        },
        octane_personal_wrongs_me: {
          "Ignore it. Karma will take care of them": {
            JoanOfArc: 0,
            HarrietTubman: 0,
            Cleopatra: 0,
            Mulan: 0,
            FridaKahlo: 0,
            RBG: 0,
            FlorenceNightingale: 0,
            MotherMary: 1,
            Nefertiti: 0,
            MarshaPJohnson: 0,
            MarieCurie: 0,
            Sappho: 0,
          },
          "Express my feelings. Even if it isn't solved, I will feel better": {
            JoanOfArc: 0,
            HarrietTubman: 1,
            Cleopatra: 0,
            Mulan: 0,
            FridaKahlo: 0,
            RBG: 0,
            FlorenceNightingale: 1,
            MotherMary: 0,
            Nefertiti: 0,
            MarshaPJohnson: 1,
            MarieCurie: 1,
            Sappho: 1,
          },
          "Confront them. I deserve explanation and resolution": {
            JoanOfArc: 0,
            HarrietTubman: 0,
            Cleopatra: 1,
            Mulan: 1,
            FridaKahlo: 0,
            RBG: 1,
            FlorenceNightingale: 0,
            MotherMary: -1,
            Nefertiti: 0,
            MarshaPJohnson: 0,
            MarieCurie: 0,
            Sappho: -1,
          },
        },
        octane_personal_admire: {
          "Creative & Unique": {
            JoanOfArc: 0,
            HarrietTubman: 0,
            Cleopatra: 0,
            Mulan: 0,
            FridaKahlo: 0,
            RBG: -1,
            FlorenceNightingale: -1,
            MotherMary: 0,
            Nefertiti: 0,
            MarshaPJohnson: 0,
            MarieCurie: -1,
            Sappho: 1,
          },
          "Wise & Eloquent": {
            JoanOfArc: 0,
            HarrietTubman: 1,
            Cleopatra: 0,
            Mulan: 0,
            FridaKahlo: 0,
            RBG: 0,
            FlorenceNightingale: 0,
            MotherMary: 1,
            Nefertiti: 0,
            MarshaPJohnson: 0,
            MarieCurie: 0,
            Sappho: 0,
          },
          "Enigmatic & Charming": {
            JoanOfArc: 0,
            HarrietTubman: 0,
            Cleopatra: 1,
            Mulan: 0,
            FridaKahlo: 0,
            RBG: -1,
            FlorenceNightingale: 0,
            MotherMary: -1,
            Nefertiti: 0,
            MarshaPJohnson: 1,
            MarieCurie: -1,
            Sappho: 0,
          },
          "Persistent & Hardworking": {
            JoanOfArc: 0,
            HarrietTubman: 1,
            Cleopatra: 1,
            Mulan: 1,
            FridaKahlo: 0,
            RBG: 1,
            FlorenceNightingale: 1,
            MotherMary: 0,
            Nefertiti: 0,
            MarshaPJohnson: 0,
            MarieCurie: 1,
            Sappho: 0,
          },
        },
        octane_personal_zodiac: {
          "Aries: Mar 21 - Apr 19": {
            JoanOfArc: 0,
            HarrietTubman: 0,
            Cleopatra: 0,
            Mulan: 0,
            FridaKahlo: 0,
            RBG: 0,
            FlorenceNightingale: 0,
            MotherMary: 0,
            Nefertiti: 0,
            MarshaPJohnson: 0,
            MarieCurie: 0,
            Sappho: 0,
          },
          "Taurus: Apr 20 - May 20": {
            JoanOfArc: 0,
            HarrietTubman: 0,
            Cleopatra: 0,
            Mulan: 0,
            FridaKahlo: 0,
            RBG: 0,
            FlorenceNightingale: 0,
            MotherMary: 0,
            Nefertiti: 0,
            MarshaPJohnson: 0,
            MarieCurie: 0,
            Sappho: 0,
          },
          "Gemini: May 21 - June 21": {
            JoanOfArc: 0,
            HarrietTubman: 0,
            Cleopatra: 0,
            Mulan: 0,
            FridaKahlo: 0,
            RBG: 0,
            FlorenceNightingale: 0,
            MotherMary: 0,
            Nefertiti: 0,
            MarshaPJohnson: 0,
            MarieCurie: 0,
            Sappho: 0,
          },
          "Cancer: June 22 - July 22": {
            JoanOfArc: 0,
            HarrietTubman: 0,
            Cleopatra: 0,
            Mulan: 0,
            FridaKahlo: 0,
            RBG: 0,
            FlorenceNightingale: 0,
            MotherMary: 0,
            Nefertiti: 0,
            MarshaPJohnson: 0,
            MarieCurie: 0,
            Sappho: 0,
          },
          "Leo: July 23 - Aug 22": {
            JoanOfArc: 0,
            HarrietTubman: 0,
            Cleopatra: 0,
            Mulan: 0,
            FridaKahlo: 0,
            RBG: 0,
            FlorenceNightingale: 0,
            MotherMary: 0,
            Nefertiti: 0,
            MarshaPJohnson: 0,
            MarieCurie: 0,
            Sappho: 0,
          },
          "Virgo: Aug 23 - Sep 22": {
            JoanOfArc: 0,
            HarrietTubman: 0,
            Cleopatra: 0,
            Mulan: 0,
            FridaKahlo: 0,
            RBG: 0,
            FlorenceNightingale: 0,
            MotherMary: 0,
            Nefertiti: 0,
            MarshaPJohnson: 0,
            MarieCurie: 0,
            Sappho: 0,
          },
          "Libra: Sep 23 - Oct 23": {
            JoanOfArc: 0,
            HarrietTubman: 0,
            Cleopatra: 0,
            Mulan: 0,
            FridaKahlo: 0,
            RBG: 0,
            FlorenceNightingale: 0,
            MotherMary: 0,
            Nefertiti: 0,
            MarshaPJohnson: 0,
            MarieCurie: 0,
            Sappho: 0,
          },
          "Scorpio: Oct 24 - Nov 21": {
            JoanOfArc: 0,
            HarrietTubman: 0,
            Cleopatra: 0,
            Mulan: 0,
            FridaKahlo: 0,
            RBG: 0,
            FlorenceNightingale: 0,
            MotherMary: 0,
            Nefertiti: 0,
            MarshaPJohnson: 0,
            MarieCurie: 0,
            Sappho: 0,
          },
          "Sagittarius: Nov 22 - Dec 21": {
            JoanOfArc: 0,
            HarrietTubman: 0,
            Cleopatra: 0,
            Mulan: 0,
            FridaKahlo: 0,
            RBG: 0,
            FlorenceNightingale: 0,
            MotherMary: 0,
            Nefertiti: 0,
            MarshaPJohnson: 0,
            MarieCurie: 0,
            Sappho: 0,
          },
          "Capricorn: Dec 22 - Jan 19": {
            JoanOfArc: 0,
            HarrietTubman: 0,
            Cleopatra: 0,
            Mulan: 0,
            FridaKahlo: 0,
            RBG: 0,
            FlorenceNightingale: 0,
            MotherMary: 0,
            Nefertiti: 0,
            MarshaPJohnson: 0,
            MarieCurie: 0,
            Sappho: 0,
          },
          "Aquarius: Jan 20 - Feb 19": {
            JoanOfArc: 0,
            HarrietTubman: 0,
            Cleopatra: 0,
            Mulan: 0,
            FridaKahlo: 0,
            RBG: 0,
            FlorenceNightingale: 0,
            MotherMary: 0,
            Nefertiti: 0,
            MarshaPJohnson: 0,
            MarieCurie: 0,
            Sappho: 0,
          },
          "Pisces: Feb 19 - Mar 20": {
            JoanOfArc: 0,
            HarrietTubman: 0,
            Cleopatra: 0,
            Mulan: 0,
            FridaKahlo: 0,
            RBG: 0,
            FlorenceNightingale: 0,
            MotherMary: 0,
            Nefertiti: 0,
            MarshaPJohnson: 0,
            MarieCurie: 0,
            Sappho: 0,
          },
        },
      },
      AngelNumber: {
        octane_personal_style: {
          BOHO: {
            111: 1,
            222: 0,
            333: 1,
            444: 0,
            555: 0,
            666: 0,
            777: 0,
            888: 0,
            999: 0,
          },
          ROMANTIC: {
            111: 0,
            222: 1,
            333: 0,
            444: 1,
            555: 0,
            666: 0,
            777: 0,
            888: 0,
            999: 0,
          },
          CLASSIC: {
            111: 0,
            222: 0,
            333: 0,
            444: 0,
            555: 0,
            666: 0,
            777: 0,
            888: 1,
            999: 0,
          },
          EDGY: {
            111: 0,
            222: 0,
            333: 0,
            444: 0,
            555: 1,
            666: 1,
            777: 0,
            888: 0,
            999: 0,
          },
          GLAM: {
            111: 0,
            222: 0,
            333: 0,
            444: 0,
            555: 0,
            666: 0,
            777: 1,
            888: 0,
            999: 0,
          },
        },
        octane_personal_description: {
          Introverted: {
            111: 0,
            222: 0,
            333: 0,
            444: 1,
            555: 0,
            666: 1,
            777: 0,
            888: 0,
            999: 0,
          },
          "I love seeing my friends, but I prefer staying home": {
            111: 0,
            222: 1,
            333: 0,
            444: 0,
            555: 1,
            666: 0,
            777: 0,
            888: 0,
            999: 1,
          },
          "Both - depends on the day": {
            111: 0,
            222: 0,
            333: 1,
            444: 0,
            555: 0,
            666: 0,
            777: 0,
            888: 0,
            999: 0,
          },
          "Going out and making memories is so much fun": {
            111: 1,
            222: 0,
            333: 0,
            444: 0,
            555: 0,
            666: 0,
            777: 0,
            888: 1,
            999: 0,
          },
          Extraverted: {
            111: 0,
            222: 0,
            333: 0,
            444: 0,
            555: 0,
            666: 0,
            777: 1,
            888: 0,
            999: 0,
          },
        },
        octane_dream_home: {
          "A quiet country cottage": {
            111: 0,
            222: 0,
            333: 0,
            444: 1,
            555: 0,
            666: 0,
            777: 0,
            888: 0,
            999: 1,
          },
          "An elegant high rise in the city": {
            111: 0,
            222: 0,
            333: 0,
            444: 0,
            555: 1,
            666: 0,
            777: 0,
            888: 0,
            999: 0,
          },
          "A sprawling mansion with gorgeous gardens": {
            111: 1,
            222: 0,
            333: 0,
            444: 0,
            555: 0,
            666: 0,
            777: 1,
            888: 1,
            999: 0,
          },
          "Mythical cabin at the edge of the woods": {
            111: 0,
            222: 0,
            333: 0,
            444: 0,
            555: 0,
            666: 1,
            777: 0,
            888: 0,
            999: 0,
          },
          "A tropical bungalow under sunny blue skies": {
            111: 0,
            222: 1,
            333: 1,
            444: 0,
            555: 0,
            666: 0,
            777: 0,
            888: 0,
            999: 0,
          },
        },
        octane_personal_charity: {
          "Gay, Lesbian, and Straight Education Network": {
            111: 0,
            222: 0,
            333: 0,
            444: 0,
            555: 0,
            666: 0,
            777: 0,
            888: 0,
            999: 0,
          },
          "Women's Earth Alliance": {
            111: 0,
            222: 0,
            333: 0,
            444: 0,
            555: 0,
            666: 0,
            777: 0,
            888: 0,
            999: 0,
          },
          "Rape, Abuse & Incest National Network": {
            111: 0,
            222: 0,
            333: 0,
            444: 0,
            555: 0,
            666: 0,
            777: 0,
            888: 0,
            999: 0,
          },
          "The National Alliance on Mental Illness": {
            111: 0,
            222: 0,
            333: 0,
            444: 0,
            555: 0,
            666: 0,
            777: 0,
            888: 0,
            999: 0,
          },
        },
        octane_personal_affirmation: {
          "Inhale the Future, Exhale the Past": {
            111: 0,
            222: 0,
            333: 0,
            444: 0,
            555: 1,
            666: 0,
            777: 0,
            888: 0,
            999: 1,
          },
          "Everything I need is Within Me": {
            111: 0,
            222: 1,
            333: 0,
            444: 0,
            555: 0,
            666: 0,
            777: 1,
            888: 0,
            999: 0,
          },
          "Say Yes to New Adventures": {
            111: 1,
            222: 0,
            333: 0,
            444: 0,
            555: 0,
            666: 0,
            777: 0,
            888: 0,
            999: 0,
          },
          "Purpose Over Perfect": {
            111: 0,
            222: 0,
            333: 1,
            444: 0,
            555: 0,
            666: 1,
            777: 0,
            888: 0,
            999: 0,
          },
          "I Am Worthy of Abundance": {
            111: 0,
            222: 0,
            333: 0,
            444: 1,
            555: 0,
            666: 0,
            777: 0,
            888: 1,
            999: 0,
          },
        },
        octane_personal_need: {
          LOVE: {
            111: 0,
            222: 0,
            333: 0,
            444: 1,
            555: 0,
            666: -1,
            777: 0,
            888: 1,
            999: 0,
          },
          "INNER PEACE": {
            111: 1,
            222: 1,
            333: 0,
            444: 0,
            555: 1,
            666: 0,
            777: 0,
            888: 0,
            999: 0,
          },
          WISDOM: {
            111: 0,
            222: 0,
            333: 1,
            444: 0,
            555: 0,
            666: 1,
            777: 0,
            888: 0,
            999: 0,
          },
          COURAGE: {
            111: 0,
            222: 0,
            333: 0,
            444: 0,
            555: 0,
            666: 0,
            777: 0,
            888: 0,
            999: 1,
          },
          HEALTH: {
            111: 0,
            222: 0,
            333: 0,
            444: 0,
            555: 0,
            666: 0,
            777: 1,
            888: 0,
            999: 0,
          },
        },
        octane_personal_animal: {
          Cat: {
            111: 1,
            222: 0,
            333: 0,
            444: 0,
            555: 0,
            666: 0,
            777: 1,
            888: 0,
            999: 0,
          },
          Rabbit: {
            111: 0,
            222: 0,
            333: 0,
            444: 1,
            555: 0,
            666: 0,
            777: 0,
            888: 1,
            999: 0,
          },
          Owl: {
            111: 1,
            222: 0,
            333: 0,
            444: 0,
            555: 0,
            666: 0,
            777: 0,
            888: 0,
            999: 1,
          },
          Wolf: {
            111: 0,
            222: 0,
            333: 0,
            444: 0,
            555: 0,
            666: 0,
            777: 0,
            888: 0,
            999: 1,
          },
          Snake: {
            111: 0,
            222: 1,
            333: 0,
            444: 0,
            555: 1,
            666: 1,
            777: 0,
            888: 0,
            999: 0,
          },
        },
        octane_personal_die: {
          "We go to heaven... or hell": {
            111: 0,
            222: 0,
            333: 0,
            444: 0,
            555: 0,
            666: 0,
            777: 0,
            888: 0,
            999: 0,
          },
          "We're reincarnated": {
            111: 1,
            222: 0,
            333: 0,
            444: 0,
            555: 1,
            666: 0,
            777: 0,
            888: 0,
            999: 1,
          },
          "Our energy is dispersed in the universe": {
            111: 0,
            222: 0,
            333: 0,
            444: 0,
            555: 0,
            666: 0,
            777: 1,
            888: 0,
            999: 0,
          },
          "We simply cease to exist": {
            111: 0,
            222: 0,
            333: 0,
            444: 0,
            555: 0,
            666: 0,
            777: 0,
            888: 0,
            999: 0,
          },
          "We haunt our enemies, that's what": {
            111: 0,
            222: 0,
            333: 0,
            444: 0,
            555: 1,
            666: 0,
            777: 0,
            888: 0,
            999: 0,
          },
        },
        octane_personal_wrongs_me: {
          "Ignore it. Karma will take care of them": {
            111: 0,
            222: 0,
            333: 0,
            444: 1,
            555: 0,
            666: 0,
            777: 0,
            888: 1,
            999: 0,
          },
          "Express my feelings. Even if it isn't solved, I will feel better": {
            111: 0,
            222: 0,
            333: 0,
            444: 0,
            555: 0,
            666: 0,
            777: 0,
            888: 0,
            999: 0,
          },
          "Confront them. I deserve explanation and resolution": {
            111: 0,
            222: 0,
            333: 0,
            444: 0,
            555: 0,
            666: 1,
            777: 0,
            888: 0,
            999: 0,
          },
        },
        octane_personal_admire: {
          "Creative & Unique": {
            111: 0,
            222: 0,
            333: 1,
            444: 0,
            555: 1,
            666: 0,
            777: 0,
            888: 0,
            999: 0,
          },
          "Wise & Eloquent": {
            111: 0,
            222: 0,
            333: 0,
            444: 0,
            555: 0,
            666: 1,
            777: 0,
            888: 0,
            999: 1,
          },
          "Enigmatic & Charming": {
            111: 1,
            222: 0,
            333: 0,
            444: 0,
            555: 0,
            666: 0,
            777: 1,
            888: 0,
            999: 0,
          },
          "Persistent & Hardworking": {
            111: 0,
            222: 0,
            333: 0,
            444: 1,
            555: 0,
            666: 0,
            777: 0,
            888: 1,
            999: 0,
          },
        },
        octane_personal_zodiac: {
          "Aries: Mar 21 - Apr 19": {
            111: 0,
            222: 0,
            333: 0,
            444: 0,
            555: 0,
            666: 0,
            777: 0,
            888: 0,
            999: 0,
          },
          "Taurus: Apr 20 - May 20": {
            111: 0,
            222: 0,
            333: 0,
            444: 0,
            555: 0,
            666: 0,
            777: 0,
            888: 0,
            999: 0,
          },
          "Gemini: May 21 - June 21": {
            111: 0,
            222: 0,
            333: 0,
            444: 0,
            555: 0,
            666: 0,
            777: 0,
            888: 0,
            999: 0,
          },
          "Cancer: June 22 - July 22": {
            111: 0,
            222: 0,
            333: 0,
            444: 0,
            555: 0,
            666: 0,
            777: 0,
            888: 0,
            999: 0,
          },
          "Leo: July 23 - Aug 22": {
            111: 0,
            222: 0,
            333: 0,
            444: 0,
            555: 0,
            666: 0,
            777: 0,
            888: 0,
            999: 0,
          },
          "Virgo: Aug 23 - Sep 22": {
            111: 0,
            222: 0,
            333: 0,
            444: 0,
            555: 0,
            666: 0,
            777: 0,
            888: 0,
            999: 0,
          },
          "Libra: Sep 23 - Oct 23": {
            111: 0,
            222: 0,
            333: 0,
            444: 0,
            555: 0,
            666: 0,
            777: 0,
            888: 0,
            999: 0,
          },
          "Scorpio: Oct 24 - Nov 21": {
            111: 0,
            222: 0,
            333: 0,
            444: 0,
            555: 0,
            666: 0,
            777: 0,
            888: 0,
            999: 0,
          },
          "Sagittarius: Nov 22 - Dec 21": {
            111: 0,
            222: 0,
            333: 0,
            444: 0,
            555: 0,
            666: 0,
            777: 0,
            888: 0,
            999: 0,
          },
          "Capricorn: Dec 22 - Jan 19": {
            111: 0,
            222: 0,
            333: 0,
            444: 0,
            555: 0,
            666: 0,
            777: 0,
            888: 0,
            999: 0,
          },
          "Aquarius: Jan 20 - Feb 19": {
            111: 0,
            222: 0,
            333: 0,
            444: 0,
            555: 0,
            666: 0,
            777: 0,
            888: 0,
            999: 0,
          },
          "Pisces: Feb 19 - Mar 20": {
            111: 0,
            222: 0,
            333: 0,
            444: 0,
            555: 0,
            666: 0,
            777: 0,
            888: 0,
            999: 0,
          },
        },
      },
      Amulet: {},
      Aura: {
        octane_personal_style: {
          BOHO: {
            Red: 1,
            Orange: 0,
            Yellow: 0,
            Green: 1,
            Blue: 0,
            Indigo: 1,
            Violet: 0,
          },
          ROMANTIC: {
            Red: 0,
            Orange: 0,
            Yellow: 0,
            Green: 0,
            Blue: 1,
            Indigo: 0,
            Violet: 0,
          },
          CLASSIC: {
            Red: 0,
            Orange: 0,
            Yellow: 1,
            Green: 0,
            Blue: 0,
            Indigo: 0,
            Violet: 0,
          },
          EDGY: {
            Red: 1,
            Orange: 0,
            Yellow: 0,
            Green: 0,
            Blue: 0,
            Indigo: 0,
            Violet: 0,
          },
          GLAM: {
            Red: 0,
            Orange: 1,
            Yellow: 0,
            Green: 0,
            Blue: 0,
            Indigo: 0,
            Violet: 1,
          },
        },
        octane_personal_description: {
          Introverted: {
            Red: 0,
            Orange: 0,
            Yellow: 0,
            Green: 0,
            Blue: 0,
            Indigo: 0,
            Violet: 1,
          },
          "I love seeing my friends, but I prefer staying home": {
            Red: 0,
            Orange: 0,
            Yellow: 0,
            Green: 1,
            Blue: 0,
            Indigo: 1,
            Violet: 0,
          },
          "Both - depends on the day": {
            Red: 0,
            Orange: 0,
            Yellow: 0,
            Green: 0,
            Blue: 1,
            Indigo: 0,
            Violet: 0,
          },
          "Going out and making memories is so much fun": {
            Red: 1,
            Orange: 0,
            Yellow: 0,
            Green: 0,
            Blue: 0,
            Indigo: 0,
            Violet: 0,
          },
          Extraverted: {
            Red: 0,
            Orange: 1,
            Yellow: 1,
            Green: 0,
            Blue: 0,
            Indigo: 0,
            Violet: 0,
          },
        },
        octane_dream_home: {
          "A quiet country cottage": {
            Red: 0,
            Orange: 0,
            Yellow: 0,
            Green: 0,
            Blue: 1,
            Indigo: 1,
            Violet: 0,
          },
          "An elegant high rise in the city": {
            Red: 1,
            Orange: 0,
            Yellow: 0,
            Green: 0,
            Blue: 0,
            Indigo: 0,
            Violet: 0,
          },
          "A sprawling mansion with gorgeous gardens": {
            Red: 0,
            Orange: 0,
            Yellow: 0,
            Green: 1,
            Blue: 0,
            Indigo: 0,
            Violet: 0,
          },
          "Mythical cabin at the edge of the woods": {
            Red: 0,
            Orange: 0,
            Yellow: 0,
            Green: 0,
            Blue: 0,
            Indigo: 0,
            Violet: 1,
          },
          "A tropical bungalow under sunny blue skies": {
            Red: 0,
            Orange: 1,
            Yellow: 1,
            Green: 0,
            Blue: 0,
            Indigo: 0,
            Violet: 0,
          },
        },
        octane_personal_charity: {
          "Gay, Lesbian, and Straight Education Network": {
            Red: 0,
            Orange: 0,
            Yellow: 0,
            Green: 0,
            Blue: 0,
            Indigo: 0,
            Violet: 0,
          },
          "Women's Earth Alliance": {
            Red: 0,
            Orange: 0,
            Yellow: 0,
            Green: 0,
            Blue: 0,
            Indigo: 0,
            Violet: 0,
          },
          "Rape, Abuse & Incest National Network": {
            Red: 0,
            Orange: 0,
            Yellow: 0,
            Green: 0,
            Blue: 0,
            Indigo: 0,
            Violet: 0,
          },
          "The National Alliance on Mental Illness": {
            Red: 0,
            Orange: 0,
            Yellow: 0,
            Green: 0,
            Blue: 0,
            Indigo: 0,
            Violet: 0,
          },
        },
        octane_personal_affirmation: {
          "Inhale the Future, Exhale the Past": {
            Red: 0,
            Orange: 0,
            Yellow: 0,
            Green: 0,
            Blue: 1,
            Indigo: 1,
            Violet: 0,
          },
          "Everything I need is Within Me": {
            Red: 0,
            Orange: 0,
            Yellow: 0,
            Green: 1,
            Blue: 0,
            Indigo: 0,
            Violet: 0,
          },
          "Say Yes to New Adventures": {
            Red: 1,
            Orange: 1,
            Yellow: 0,
            Green: 0,
            Blue: 0,
            Indigo: 0,
            Violet: 0,
          },
          "Purpose Over Perfect": {
            Red: 1,
            Orange: 0,
            Yellow: 1,
            Green: 0,
            Blue: 0,
            Indigo: 0,
            Violet: 0,
          },
          "I Am Worthy of Abundance": {
            Red: 0,
            Orange: 0,
            Yellow: 0,
            Green: 1,
            Blue: 0,
            Indigo: 0,
            Violet: 1,
          },
        },
        octane_personal_need: {
          LOVE: {
            Red: 1,
            Orange: 1,
            Yellow: 0,
            Green: 0,
            Blue: 0,
            Indigo: 0,
            Violet: 0,
          },
          "INNER PEACE": {
            Red: 0,
            Orange: 0,
            Yellow: 0,
            Green: 0,
            Blue: 0,
            Indigo: 1,
            Violet: 0,
          },
          WISDOM: {
            Red: 0,
            Orange: 0,
            Yellow: 1,
            Green: 0,
            Blue: 0,
            Indigo: 0,
            Violet: 1,
          },
          COURAGE: {
            Red: 1,
            Orange: 0,
            Yellow: 0,
            Green: 0,
            Blue: 1,
            Indigo: 0,
            Violet: 0,
          },
          HEALTH: {
            Red: 0,
            Orange: 0,
            Yellow: 0,
            Green: 1,
            Blue: 0,
            Indigo: 0,
            Violet: 0,
          },
        },
        octane_personal_animal: {
          Cat: {
            Red: 0,
            Orange: 1,
            Yellow: 1,
            Green: 0,
            Blue: 0,
            Indigo: 0,
            Violet: 0,
          },
          Rabbit: {
            Red: 0,
            Orange: 0,
            Yellow: 0,
            Green: 1,
            Blue: 0,
            Indigo: 0,
            Violet: 0,
          },
          Owl: {
            Red: 0,
            Orange: 0,
            Yellow: 0,
            Green: 0,
            Blue: 0,
            Indigo: 0,
            Violet: 1,
          },
          Wolf: {
            Red: 1,
            Orange: 0,
            Yellow: 0,
            Green: 0,
            Blue: 0,
            Indigo: 0,
            Violet: 0,
          },
          Snake: {
            Red: 0,
            Orange: 0,
            Yellow: 0,
            Green: 0,
            Blue: 1,
            Indigo: 1,
            Violet: 0,
          },
        },
        octane_personal_die: {
          "We go to heaven... or hell": {
            Red: 0,
            Orange: 0,
            Yellow: 0,
            Green: 0,
            Blue: 0,
            Indigo: 0,
            Violet: 0,
          },
          "We're reincarnated": {
            Red: 0,
            Orange: 0,
            Yellow: 0,
            Green: 0,
            Blue: 0,
            Indigo: 0,
            Violet: 0,
          },
          "Our energy is dispersed in the universe": {
            Red: 0,
            Orange: 0,
            Yellow: 0,
            Green: 0,
            Blue: 0,
            Indigo: 0,
            Violet: 0,
          },
          "We simply cease to exist": {
            Red: 0,
            Orange: 0,
            Yellow: 0,
            Green: 0,
            Blue: 0,
            Indigo: 0,
            Violet: 0,
          },
          "We haunt our enemies, that's what": {
            Red: 0,
            Orange: 0,
            Yellow: 0,
            Green: 0,
            Blue: 0,
            Indigo: 0,
            Violet: 0,
          },
        },
        octane_personal_wrongs_me: {
          "Ignore it. Karma will take care of them": {
            Red: 0,
            Orange: 0,
            Yellow: 0,
            Green: 0,
            Blue: 0,
            Indigo: 1,
            Violet: 1,
          },
          "Express my feelings. Even if it isn't solved, I will feel better": {
            Red: 0,
            Orange: 1,
            Yellow: 1,
            Green: 1,
            Blue: 1,
            Indigo: 0,
            Violet: 0,
          },
          "Confront them. I deserve explanation and resolution": {
            Red: 1,
            Orange: 0,
            Yellow: 0,
            Green: 0,
            Blue: 0,
            Indigo: 0,
            Violet: 0,
          },
        },
        octane_personal_admire: {
          "Creative & Unique": {
            Red: 0,
            Orange: 0,
            Yellow: 1,
            Green: 1,
            Blue: 0,
            Indigo: 0,
            Violet: 0,
          },
          "Wise & Eloquent": {
            Red: 0,
            Orange: 0,
            Yellow: 0,
            Green: 0,
            Blue: 1,
            Indigo: 1,
            Violet: 0,
          },
          "Enigmatic & Charming": {
            Red: 0,
            Orange: 1,
            Yellow: 0,
            Green: 0,
            Blue: 0,
            Indigo: 0,
            Violet: 1,
          },
          "Persistent & Hardworking": {
            Red: 1,
            Orange: 0,
            Yellow: 0,
            Green: 0,
            Blue: 0,
            Indigo: 0,
            Violet: 0,
          },
        },
        octane_personal_zodiac: {
          "Aries: Mar 21 - Apr 19": {
            Red: 0,
            Orange: 0,
            Yellow: 0,
            Green: 0,
            Blue: 0,
            Indigo: 0,
            Violet: 0,
          },
          "Taurus: Apr 20 - May 20": {
            Red: 0,
            Orange: 0,
            Yellow: 0,
            Green: 0,
            Blue: 0,
            Indigo: 0,
            Violet: 0,
          },
          "Gemini: May 21 - June 21": {
            Red: 0,
            Orange: 0,
            Yellow: 0,
            Green: 0,
            Blue: 0,
            Indigo: 0,
            Violet: 0,
          },
          "Cancer: June 22 - July 22": {
            Red: 0,
            Orange: 1,
            Yellow: 0,
            Green: 0,
            Blue: 0,
            Indigo: 0,
            Violet: 0,
          },
          "Leo: July 23 - Aug 22": {
            Red: 0,
            Orange: 0,
            Yellow: 0,
            Green: 0,
            Blue: 0,
            Indigo: 0,
            Violet: 0,
          },
          "Virgo: Aug 23 - Sep 22": {
            Red: 0,
            Orange: 0,
            Yellow: 0,
            Green: 0,
            Blue: 0,
            Indigo: 0,
            Violet: 0,
          },
          "Libra: Sep 23 - Oct 23": {
            Red: 0,
            Orange: 0,
            Yellow: 0,
            Green: 0,
            Blue: 0,
            Indigo: 0,
            Violet: 0,
          },
          "Scorpio: Oct 24 - Nov 21": {
            Red: 0,
            Orange: 0,
            Yellow: 0,
            Green: 0,
            Blue: 0,
            Indigo: 0,
            Violet: 0,
          },
          "Sagittarius: Nov 22 - Dec 21": {
            Red: 0,
            Orange: 0,
            Yellow: 0,
            Green: 0,
            Blue: 0,
            Indigo: 0,
            Violet: 0,
          },
          "Capricorn: Dec 22 - Jan 19": {
            Red: 0,
            Orange: 0,
            Yellow: 0,
            Green: 0,
            Blue: 0,
            Indigo: 0,
            Violet: 0,
          },
          "Aquarius: Jan 20 - Feb 19": {
            Red: 0,
            Orange: 0,
            Yellow: 0,
            Green: 0,
            Blue: 0,
            Indigo: 0,
            Violet: 0,
          },
          "Pisces: Feb 19 - Mar 20": {
            Red: 0,
            Orange: 0,
            Yellow: 0,
            Green: 0,
            Blue: 0,
            Indigo: 0,
            Violet: 0,
          },
        },
      },
      Affirmations: {
        octane_personal_affirmation: {
          "Inhale the Future, Exhale the Past": {
            "Inhale the Future, Exhale the Past": 1,
          },
          "Everything I need is Within Me": {
            "Everything I need is Within Me": 1,
          },
          "Say Yes to New Adventures": { "Say Yes to New Adventures": 1 },
          "Purpose Over Perfect": { "Purpose Over Perfect": 1 },
          "I Am Worthy of Abundance": { "I Am Worthy of Abundance": 1 },
        },
      },
      Elements: {
        octane_personal_zodiac: {
          "Aries: Mar 21 - Apr 19": { "Aries: Mar 21 - Apr 19": 1 },
          "Taurus: Apr 20 - May 20": { "Taurus: Apr 20 - May 20": 1 },
          "Gemini: May 21 - June 21": { "Gemini: May 21 - June 21": 1 },
          "Cancer: June 22 - July 22": { "Cancer: June 22 - July 22": 1 },
          "Leo: July 23 - Aug 22": { "Leo: July 23 - Aug 22": 1 },
          "Virgo: Aug 23 - Sep 22": { "Virgo: Aug 23 - Sep 22": 1 },
          "Libra: Sep 23 - Oct 23": { "Libra: Sep 23 - Oct 23": 1 },
          "Scorpio: Oct 24 - Nov 21": { "Scorpio: Oct 24 - Nov 21": 1 },
          "Sagittarius: Nov 22 - Dec 21": { "Sagittarius: Nov 22 - Dec 21": 1 },
          "Capricorn: Dec 22 - Jan 19": { "Capricorn: Dec 22 - Jan 19": 1 },
          "Aquarius: Jan 20 - Feb 19": { "Aquarius: Jan 20 - Feb 19": 1 },
          "Pisces: Feb 19 - Mar 20": { "Pisces: Feb 19 - Mar 20": 1 },
        },
      },
      SunSign: {
        octane_personal_zodiac: {
          "Aries: Mar 21 - Apr 19": { "Aries: Mar 21 - Apr 19": 1 },
          "Taurus: Apr 20 - May 20": { "Taurus: Apr 20 - May 20": 1 },
          "Gemini: May 21 - June 21": { "Gemini: May 21 - June 21": 1 },
          "Cancer: June 22 - July 22": { "Cancer: June 22 - July 22": 1 },
          "Leo: July 23 - Aug 22": { "Leo: July 23 - Aug 22": 1 },
          "Virgo: Aug 23 - Sep 22": { "Virgo: Aug 23 - Sep 22": 1 },
          "Libra: Sep 23 - Oct 23": { "Libra: Sep 23 - Oct 23": 1 },
          "Scorpio: Oct 24 - Nov 21": { "Scorpio: Oct 24 - Nov 21": 1 },
          "Sagittarius: Nov 22 - Dec 21": { "Sagittarius: Nov 22 - Dec 21": 1 },
          "Capricorn: Dec 22 - Jan 19": { "Capricorn: Dec 22 - Jan 19": 1 },
          "Aquarius: Jan 20 - Feb 19": { "Aquarius: Jan 20 - Feb 19": 1 },
          "Pisces: Feb 19 - Mar 20": { "Pisces: Feb 19 - Mar 20": 1 },
        },
      },
    };
  function i(e, i) {
    let n = a[e];
    for (let a in i)
      if (r[e] && r[e][a]) {
        let t = i[a],
          o = r[e][a][t];
        if (o)
          for (let e in o)
            o.hasOwnProperty(e) &&
              ((n[e] += o[e]),
              console.log(`Added ${o[e]} to ${e} for ${a}=${t}`));
        else
          console.log(`No mapping found for answer "${t}" in question "${a}"`);
      } else
        console.log(`No mapping found for question "${a}" in category "${e}"`);
    return Object.keys(n)
      .sort((e, a) => n[a] - n[e])
      .slice(0, 2);
  }
  let n = (function (e) {
    let r = {};
    for (let n in a) {
      let a = i(n, e);
      r[n] = a;
    }
    return r;
  })(e);
  return JSON.stringify(n, null, 2);
}
const productIds = {
  Mythological: {
    Aphrodite: "f35b05ada15c9662015bcfda495bd3f1a5377748",
    Athena: "bb4af6b396550fda975942593a3c0ecec6df8c53",
    Freya: "d509625321dd0b5a36912032a3911afadb0453f3",
    Hecate: "a2fd72c240e2713ddb9da35acdb9bcc767724a44",
    Isis: "606793a89ca08d47ff7bf5d3cc5804af16e4a28c",
    Lilith: "37d55f207e16f14c73fa679fb2f8e789a3d3aa30",
    Medusa: "7bb2152395e335c5f7ef7e251c3fef57086d915e",
    Persephone: "c6e2aa57d229ee12384fae582310bd82ef417ab2",
    MotherEarth: "48418164b021d3a92b1fce45cc7a8ae7451db5ef",
    Selene: "8c8548ec2edf3a0826443a4b8c32b0814405b687",
    Brigid: "a7fcfbb47c65e299f5374d60cfc6e676a9f1a53c",
    TheMorrigan: "32a0c0388bf674710a29b2570f70ac47f8525c0e",
    Bastet: "09437606ac4b6a3e5a8704659c1dbeb2d3591daf",
    Guadalupe: "01650319b7b2d5939b6a57365e491c5b6c7f325a",
    Asteria: "643638b5c06f3451a48a0fa41ee5673721a96263",
    Psyche: "23d9b77db05b5fdcf2e76b2407be8bcb4eec68f8",
    LadyBuddha: "283bed443d21d5d14e958b85a383e6e5da2f739a",
    Rhiannon: "2537c3935383d1106779c22e124140e5c5ae348d",
    Oshun: "b31eaae76601630d64376b446461e84617d14197",
    Nemesis: "17e59da6591260af30bd452fe8d8253f62450190",
    Hermaphroditus: "ba1c16195aa64a06097a9d4e3391de9545d8e7a5",
    Fortuna: "ca6e1bad2e79bf08520a4d90096b77d6623838df",
    Artemis: "d02844324b75e29a7bc7e0940ecb5a61651b36fd",
    Lakshmi: "4236dca6523a0ec5efc6d395ae99b179b9ebb6c1",
  },
  IRL: {
    JoanOfArc: "56850b4b9db04699ac223aa8bacaff2c05e27629",
    HarrietTubman: "afeb9ce351eda05a987e6b6fbd836de648aa8331",
    Cleopatra: "0e61fc2a6265133ede6605a35061940983ef2c01",
    Mulan: "b89ba32ec8c6111f9027c94be7bd28360ac74ad0",
    FridaKahlo: "b4aa9c90f1e6724302fd2d7178c202bedb0601a7",
    RBG: "5f63df51dc93c256602e4515d243ebfd0ebe1e68",
    FlorenceNightingale: "53c18ba23874461432d559b832728e5c76c37ef4",
    MotherMary: "db85ac7514c2a1e0dbe04cf56429034a33e7c939",
    Nefertiti: "",
    MarshaPJohnson: "77f67a15be1f201e111b7cde5a2ad9feadaf6e77",
    MarieCurie: "cba93a01faee8b8e113b63f9ec7a48fa5eecbeb2",
    Sappho: "630182eab780af6100ce992c55997f118ce829bb",
  },
  AngelNumber: {
    111: "6d5faf1173bcb8e51f24dfd8d2fd9bfb1290c7ce",
    222: "401d354d4357f729801b87d40fe9d1aed9d57789",
    333: "964bcb181aeb655888b9812a2c4f2bcc16dddb63",
    444: "dd9f87a8569de270cd20014dc1939407e4b380b9",
    555: "7f3dfff926f47b7554cac4298c5de74015ed2b91",
    666: "c18678de3ae46a289123719349eaa9e4a3e555a7",
    777: "64d9faaa6c2fa3d2bc88f6a144847cf68ba66606",
    888: "92ddf5fb6e269d442cec5e0ad802ad6f9668b5e2",
    999: "65faa022b1c79b57bbba96e8653d3b815b4c70d2",
  },
  Amulet: {
    GateOfHades: "f53887cbec5ed155f0b536f7ef58b1ce32919fcc",
    WomanPower: "c9e7cc38940c3b48b27dce608e97b268f62bdd23",
    SpikedHeart: "4c80cf35ac0dc8bdb0226d5a42dc517cd043ec76",
    OpalSun: "fd98bce9793ce8e699a3f08b11d6357d6cf54e9d",
    DiamondMoonWave: "dc98eee769e21ea9e3f7681c96a3b2973f11eb76",
    TripleMoon: "ae986b4fc3cceaebf680a9f8c2bd5c02067dde8f",
    DiamondSword: "de96671aab57aa95771aa4da7dd6ac5a0afdcb99",
    CrescentSnakeEye: "8e78d7a72411a0c20de48dd2f4f8ab869375a882",
    MagicMushroom: "1329d8a30161c9bfe08c5d34f051300a9e912d24",
    Pomegranate: "ab0ee43c50f9949e7c92e327f22c1e18a3c80ddc",
    MagicalCat: "02e88250403999406ccf22978645d03afde9759a",
    LuckyDragonfly: "975a74f57ec9e9be12bb452a1eb83db37c4ddf18",
  },
  Aura: {
    Red: "c01a03832d4a9d15e4d98437f85a02bcc9437a85",
    Orange: "ae69d736482f74f977f42db08a4328260f7b8655",
    Yellow: "6717af620e63495e9bc8a96ca341938c7bb890ae",
    Green: "ff5e0b66467ac107b34f422a913173e12489cca7",
    Blue: "34426562048c44a4b75814e28ddedcfc073bbfc2",
    Indigo: "9e0b6407e74ad3db14608e10396e8861c127da44",
    Violet: "b937e1db93d95bdd8447b298107d3a1d7cc9f440",
  },
  Affirmations: {
    "Inhale the Future, Exhale the Past":
      "679f9c90717c0afd14ce7b690c86046313d314ad",
    "Everything I need is Within Me":
      "4db040cbe412cc8d08b5f05570155414d7b4beb5",
    "Say Yes to New Adventures": "93570e970b80cec71d391041ae636adc950c4786",
    "Purpose Over Perfect": "703d1474da3c2a055f63013459bd5a1f74106dc9",
    "I Am Worthy of Abundance": "76e73eb33792c5819073b7e193be1377b9170833",
  },
  Elements: {
    "Aries: Mar 21 - Apr 19": "9a198d2c6ad9577e75fe653841b01b7de93e97a5",
    "Taurus: Apr 20 - May 20": "1c1b7cc75752574fa00e448b4518139730716f60",
    "Gemini: May 21 - June 21": "c0fab9e8126715376b2f2359983b75fb563b4736",
    "Cancer: June 22 - July 22": "e1528d84e25b134f3113d892904e07cb47387871",
    "Leo: July 23 - Aug 22": "6808a15a634f19f9bf2c56183124a8ee48690a0e",
    "Virgo: Aug 23 - Sep 22": "ecae2d891df20ba4080edbfbd69b7325a7d45e94",
    "Libra: Sep 23 - Oct 23": "6530b2b35095647e1625273a9ab69cc319eacc2a",
    "Scorpio: Oct 24 - Nov 21": "e5cd9045179bb7607e0e59ebbf6f21d0bf851c74",
    "Sagittarius: Nov 22 - Dec 21": "b32cfdb548a11420561ad0e139a26b2e9402ebe3",
    "Capricorn: Dec 22 - Jan 19": "97044b688c926ac13a1779203ac7ab8f604a108f",
    "Aquarius: Jan 20 - Feb 19": "9d85d11be917b073ba9707fa35014ad67db557cc",
    "Pisces: Feb 19 - Mar 20": "e099c8dfeb097d4a5b98e25849e9eac6b3f44506",
  },
  SunSign: {
    "Aries: Mar 21 - Apr 19": "634188646fe2b164b93e899bee7a12cd4975a212",
    "Taurus: Apr 20 - May 20": "5e053a39620c12817c1da83114a46eb80db9cd8a",
    "Gemini: May 21 - June 21": "475c26404c28d9f7675b22f1899cb90d9d31651b",
    "Cancer: June 22 - July 22": "ba1b260fa8e82e6013137d8095ee858c54758a3d",
    "Leo: July 23 - Aug 22": "de49d67983033d1fae102c703fad019311037819",
    "Virgo: Aug 23 - Sep 22": "e926652e03d8d3f9520be2872806089dacfdcd1d",
    "Libra: Sep 23 - Oct 23": "ec3b878bf6dd75d6b84560e11a64fc00be6c77dc",
    "Scorpio: Oct 24 - Nov 21": "445589f5f59c66cf97cc11d92a07730ef42976d6",
    "Sagittarius: Nov 22 - Dec 21": "d4a97bcfc528ac7da015fe7e5a08f17317c1fafa",
    "Capricorn: Dec 22 - Jan 19": "9e856db9f9c2d5aa709d3d62493dd40bc7b15c90",
    "Aquarius: Jan 20 - Feb 19": "b10ff7ff69ec08f62fade40af52bde7a355ecec4",
    "Pisces: Feb 19 - Mar 20": "e394326f0e3cf88292aa1f0c30049219e37fe1aa",
  },
};
const UNIFIED_GODDESS_DATA = {
  product: {
    id: 8695485956148,
    title: "Goddess Necklace",
    body_html:
      '<p dir="ltr"><span>Carry the power of the Goddess with you. A classic Awe design, each pendant features a mythological Goddess. Her relief is designed by hand based on historical art and symbology and hand polished to finish. Pair your Goddess with her amulet to enhance her power. This 20mm size can be worn with a halo.</span></p>\n<p class="p1"><strong>Aphrodite</strong>, Goddess of self-love and beauty</p>\n<p class="p1"><strong>Artemis</strong>, Goddess of the hunt and the wild</p>\n<p class="p1"><strong>Athena</strong>, Goddess of wisdom and courage</p>\n<p class="p1"><strong>Freya</strong>, Goddess of love, sex and war</p>\n<p class="p1"><strong>Hecate</strong>, Goddess of magic and transformation</p>\n<p class="p1"><strong>Lilith</strong>, Goddess of feminine rage and autonomy</p>\n<p class="p1"><strong>Medusa</strong>, Goddess of retribution and protection</p>\n<p class="p1"><strong>Persephone</strong>, Goddess of transformation and springtime</p>\n<p class="p1"><strong>Rhiannon</strong>, Goddess of sovereignty and horses</p>\n<p class="p1"><strong>Selene</strong>, Goddess of the moon and intuition</p>',
    vendor: "Awe Inspired",
    product_type: "Necklaces",
    created_at: "2025-11-14T19:21:44-08:00",
    handle: "goddess-necklace",
    updated_at: "2025-11-26T14:25:41-08:00",
    published_at: "2025-11-19T17:50:48-08:00",
    template_suffix: null,
    published_scope: "global",
    tags: "best gifts, Best Sellers, collection Pendant Necklaces, collection_Goddess, Collection_Necklace, collection_Necklaces, GG25|EMPOWERED, Goddess Charm Necklaces, Goddess Coin Necklaces, PDM-Test, Welcome to Awe, YGroup_goddess",
    variants: [
      {
        id: 47259473346612,
        product_id: 8695485956148,
        title: "925 Sterling Silver / Rhiannon / 16-18",
        price: "150.00",
        sku: "N-1008478",
        position: 1,
        compare_at_price: "220.00",
        fulfillment_service: "manual",
        inventory_management: "shopify",
        option1: "925 Sterling Silver",
        option2: "Rhiannon",
        option3: "16-18",
        created_at: "2025-11-14T19:22:05-08:00",
        updated_at: "2025-11-26T14:25:41-08:00",
        taxable: true,
        barcode: "",
        grams: 0,
        image_id: 36020717453364,
        weight: 0.0,
        weight_unit: "kg",
        requires_shipping: true,
        quantity_rule: { min: 1, max: null, increment: 1 },
        price_currency: "USD",
        compare_at_price_currency: "USD",
        quantity_price_breaks: [],
      },
      {
        id: 47259473379380,
        product_id: 8695485956148,
        title: "925 Sterling Silver / Rhiannon / 20-22",
        price: "155.00",
        sku: "N-1008479",
        position: 2,
        compare_at_price: "230.00",
        fulfillment_service: "manual",
        inventory_management: "shopify",
        option1: "925 Sterling Silver",
        option2: "Rhiannon",
        option3: "20-22",
        created_at: "2025-11-14T19:22:07-08:00",
        updated_at: "2025-11-26T14:25:41-08:00",
        taxable: true,
        barcode: "",
        grams: 0,
        image_id: 36020717453364,
        weight: 0.0,
        weight_unit: "kg",
        requires_shipping: true,
        quantity_rule: { min: 1, max: null, increment: 1 },
        price_currency: "USD",
        compare_at_price_currency: "USD",
        quantity_price_breaks: [],
      },
      {
        id: 47259472887860,
        product_id: 8695485956148,
        title: "925 Sterling Silver / Freya / 16-18",
        price: "150.00",
        sku: "N-1008458",
        position: 3,
        compare_at_price: "220.00",
        fulfillment_service: "manual",
        inventory_management: "shopify",
        option1: "925 Sterling Silver",
        option2: "Freya",
        option3: "16-18",
        created_at: "2025-11-14T19:21:44-08:00",
        updated_at: "2025-11-26T14:25:41-08:00",
        taxable: true,
        barcode: "",
        grams: 0,
        image_id: 36028501819444,
        weight: 0.0,
        weight_unit: "kg",
        requires_shipping: true,
        quantity_rule: { min: 1, max: null, increment: 1 },
        price_currency: "USD",
        compare_at_price_currency: "USD",
        quantity_price_breaks: [],
      },
      {
        id: 47259472920628,
        product_id: 8695485956148,
        title: "925 Sterling Silver / Freya / 20-22",
        price: "155.00",
        sku: "N-1008459",
        position: 4,
        compare_at_price: "230.00",
        fulfillment_service: "manual",
        inventory_management: "shopify",
        option1: "925 Sterling Silver",
        option2: "Freya",
        option3: "20-22",
        created_at: "2025-11-14T19:21:51-08:00",
        updated_at: "2025-11-26T14:25:41-08:00",
        taxable: true,
        barcode: "",
        grams: 0,
        image_id: 36028501819444,
        weight: 0.0,
        weight_unit: "kg",
        requires_shipping: true,
        quantity_rule: { min: 1, max: null, increment: 1 },
        price_currency: "USD",
        compare_at_price_currency: "USD",
        quantity_price_breaks: [],
      },
      {
        id: 47259472953396,
        product_id: 8695485956148,
        title: "925 Sterling Silver / Athena / 16-18",
        price: "150.00",
        sku: "N-1008454",
        position: 5,
        compare_at_price: "220.00",
        fulfillment_service: "manual",
        inventory_management: "shopify",
        option1: "925 Sterling Silver",
        option2: "Athena",
        option3: "16-18",
        created_at: "2025-11-14T19:21:54-08:00",
        updated_at: "2025-11-26T14:25:41-08:00",
        taxable: true,
        barcode: "",
        grams: 0,
        image_id: 36020712472628,
        weight: 0.0,
        weight_unit: "kg",
        requires_shipping: true,
        quantity_rule: { min: 1, max: null, increment: 1 },
        price_currency: "USD",
        compare_at_price_currency: "USD",
        quantity_price_breaks: [],
      },
      {
        id: 47259472986164,
        product_id: 8695485956148,
        title: "925 Sterling Silver / Athena / 20-22",
        price: "155.00",
        sku: "N-1008455",
        position: 6,
        compare_at_price: "230.00",
        fulfillment_service: "manual",
        inventory_management: "shopify",
        option1: "925 Sterling Silver",
        option2: "Athena",
        option3: "20-22",
        created_at: "2025-11-14T19:21:55-08:00",
        updated_at: "2025-11-26T14:25:41-08:00",
        taxable: true,
        barcode: "",
        grams: 0,
        image_id: 36020712472628,
        weight: 0.0,
        weight_unit: "kg",
        requires_shipping: true,
        quantity_rule: { min: 1, max: null, increment: 1 },
        price_currency: "USD",
        compare_at_price_currency: "USD",
        quantity_price_breaks: [],
      },
      {
        id: 47259473018932,
        product_id: 8695485956148,
        title: "925 Sterling Silver / Hecate / 16-18",
        price: "150.00",
        sku: "N-1008464",
        position: 7,
        compare_at_price: "220.00",
        fulfillment_service: "manual",
        inventory_management: "shopify",
        option1: "925 Sterling Silver",
        option2: "Hecate",
        option3: "16-18",
        created_at: "2025-11-14T19:21:56-08:00",
        updated_at: "2025-11-26T14:25:41-08:00",
        taxable: true,
        barcode: "",
        grams: 0,
        image_id: 36020715126836,
        weight: 0.0,
        weight_unit: "kg",
        requires_shipping: true,
        quantity_rule: { min: 1, max: null, increment: 1 },
        price_currency: "USD",
        compare_at_price_currency: "USD",
        quantity_price_breaks: [],
      },
      {
        id: 47259473051700,
        product_id: 8695485956148,
        title: "925 Sterling Silver / Hecate / 20-22",
        price: "155.00",
        sku: "N-1008463",
        position: 8,
        compare_at_price: "230.00",
        fulfillment_service: "manual",
        inventory_management: "shopify",
        option1: "925 Sterling Silver",
        option2: "Hecate",
        option3: "20-22",
        created_at: "2025-11-14T19:21:57-08:00",
        updated_at: "2025-11-26T14:25:41-08:00",
        taxable: true,
        barcode: "",
        grams: 0,
        image_id: 36020715126836,
        weight: 0.0,
        weight_unit: "kg",
        requires_shipping: true,
        quantity_rule: { min: 1, max: null, increment: 1 },
        price_currency: "USD",
        compare_at_price_currency: "USD",
        quantity_price_breaks: [],
      },
      {
        id: 47259473084468,
        product_id: 8695485956148,
        title: "925 Sterling Silver / Lilith / 16-18",
        price: "150.00",
        sku: "N-1008466",
        position: 9,
        compare_at_price: "220.00",
        fulfillment_service: "manual",
        inventory_management: "shopify",
        option1: "925 Sterling Silver",
        option2: "Lilith",
        option3: "16-18",
        created_at: "2025-11-14T19:21:58-08:00",
        updated_at: "2025-11-26T14:25:41-08:00",
        taxable: true,
        barcode: "",
        grams: 0,
        image_id: 36020479950900,
        weight: 0.0,
        weight_unit: "kg",
        requires_shipping: true,
        quantity_rule: { min: 1, max: null, increment: 1 },
        price_currency: "USD",
        compare_at_price_currency: "USD",
        quantity_price_breaks: [],
      },
      {
        id: 47259473117236,
        product_id: 8695485956148,
        title: "925 Sterling Silver / Lilith / 20-22",
        price: "155.00",
        sku: "N-1008467",
        position: 10,
        compare_at_price: "230.00",
        fulfillment_service: "manual",
        inventory_management: "shopify",
        option1: "925 Sterling Silver",
        option2: "Lilith",
        option3: "20-22",
        created_at: "2025-11-14T19:21:58-08:00",
        updated_at: "2025-11-26T14:25:41-08:00",
        taxable: true,
        barcode: "",
        grams: 0,
        image_id: 36020479950900,
        weight: 0.0,
        weight_unit: "kg",
        requires_shipping: true,
        quantity_rule: { min: 1, max: null, increment: 1 },
        price_currency: "USD",
        compare_at_price_currency: "USD",
        quantity_price_breaks: [],
      },
      {
        id: 47259473150004,
        product_id: 8695485956148,
        title: "925 Sterling Silver / Medusa / 16-18",
        price: "150.00",
        sku: "N-1008470",
        position: 11,
        compare_at_price: "220.00",
        fulfillment_service: "manual",
        inventory_management: "shopify",
        option1: "925 Sterling Silver",
        option2: "Medusa",
        option3: "16-18",
        created_at: "2025-11-14T19:21:59-08:00",
        updated_at: "2025-11-26T14:25:41-08:00",
        taxable: true,
        barcode: "",
        grams: 0,
        image_id: 36020493123636,
        weight: 0.0,
        weight_unit: "kg",
        requires_shipping: true,
        quantity_rule: { min: 1, max: null, increment: 1 },
        price_currency: "USD",
        compare_at_price_currency: "USD",
        quantity_price_breaks: [],
      },
      {
        id: 47259473182772,
        product_id: 8695485956148,
        title: "925 Sterling Silver / Medusa / 20-22",
        price: "155.00",
        sku: "N-1008471",
        position: 12,
        compare_at_price: "230.00",
        fulfillment_service: "manual",
        inventory_management: "shopify",
        option1: "925 Sterling Silver",
        option2: "Medusa",
        option3: "20-22",
        created_at: "2025-11-14T19:22:00-08:00",
        updated_at: "2025-11-26T14:25:41-08:00",
        taxable: true,
        barcode: "",
        grams: 0,
        image_id: 36020493123636,
        weight: 0.0,
        weight_unit: "kg",
        requires_shipping: true,
        quantity_rule: { min: 1, max: null, increment: 1 },
        price_currency: "USD",
        compare_at_price_currency: "USD",
        quantity_price_breaks: [],
      },
      {
        id: 47259473215540,
        product_id: 8695485956148,
        title: "925 Sterling Silver / Selene / 16-18",
        price: "150.00",
        sku: "N-1008482",
        position: 13,
        compare_at_price: "220.00",
        fulfillment_service: "manual",
        inventory_management: "shopify",
        option1: "925 Sterling Silver",
        option2: "Selene",
        option3: "16-18",
        created_at: "2025-11-14T19:22:01-08:00",
        updated_at: "2025-11-26T14:25:41-08:00",
        taxable: true,
        barcode: "",
        grams: 0,
        image_id: 36020494434356,
        weight: 0.0,
        weight_unit: "kg",
        requires_shipping: true,
        quantity_rule: { min: 1, max: null, increment: 1 },
        price_currency: "USD",
        compare_at_price_currency: "USD",
        quantity_price_breaks: [],
      },
      {
        id: 47259473248308,
        product_id: 8695485956148,
        title: "925 Sterling Silver / Selene / 20-22",
        price: "155.00",
        sku: "N-1008483",
        position: 14,
        compare_at_price: "230.00",
        fulfillment_service: "manual",
        inventory_management: "shopify",
        option1: "925 Sterling Silver",
        option2: "Selene",
        option3: "20-22",
        created_at: "2025-11-14T19:22:02-08:00",
        updated_at: "2025-11-26T14:25:41-08:00",
        taxable: true,
        barcode: "",
        grams: 0,
        image_id: 36020494434356,
        weight: 0.0,
        weight_unit: "kg",
        requires_shipping: true,
        quantity_rule: { min: 1, max: null, increment: 1 },
        price_currency: "USD",
        compare_at_price_currency: "USD",
        quantity_price_breaks: [],
      },
      {
        id: 47259473281076,
        product_id: 8695485956148,
        title: "925 Sterling Silver / Artemis / 16-18",
        price: "150.00",
        sku: "N-1008450",
        position: 15,
        compare_at_price: "220.00",
        fulfillment_service: "manual",
        inventory_management: "shopify",
        option1: "925 Sterling Silver",
        option2: "Artemis",
        option3: "16-18",
        created_at: "2025-11-14T19:22:03-08:00",
        updated_at: "2025-11-26T14:25:41-08:00",
        taxable: true,
        barcode: "",
        grams: 0,
        image_id: 36020461731892,
        weight: 0.0,
        weight_unit: "kg",
        requires_shipping: true,
        quantity_rule: { min: 1, max: null, increment: 1 },
        price_currency: "USD",
        compare_at_price_currency: "USD",
        quantity_price_breaks: [],
      },
      {
        id: 47259473313844,
        product_id: 8695485956148,
        title: "925 Sterling Silver / Artemis / 20-22",
        price: "155.00",
        sku: "N-1008451",
        position: 16,
        compare_at_price: "230.00",
        fulfillment_service: "manual",
        inventory_management: "shopify",
        option1: "925 Sterling Silver",
        option2: "Artemis",
        option3: "20-22",
        created_at: "2025-11-14T19:22:04-08:00",
        updated_at: "2025-11-26T14:25:41-08:00",
        taxable: true,
        barcode: "",
        grams: 0,
        image_id: 36020461731892,
        weight: 0.0,
        weight_unit: "kg",
        requires_shipping: true,
        quantity_rule: { min: 1, max: null, increment: 1 },
        price_currency: "USD",
        compare_at_price_currency: "USD",
        quantity_price_breaks: [],
      },
      {
        id: 47259473412148,
        product_id: 8695485956148,
        title: "925 Sterling Silver / Aphrodite / 16-18",
        price: "150.00",
        sku: "N-1008446",
        position: 17,
        compare_at_price: "220.00",
        fulfillment_service: "manual",
        inventory_management: "shopify",
        option1: "925 Sterling Silver",
        option2: "Aphrodite",
        option3: "16-18",
        created_at: "2025-11-14T19:22:08-08:00",
        updated_at: "2025-11-26T14:25:41-08:00",
        taxable: true,
        barcode: "",
        grams: 0,
        image_id: 36020710309940,
        weight: 0.0,
        weight_unit: "kg",
        requires_shipping: true,
        quantity_rule: { min: 1, max: null, increment: 1 },
        price_currency: "USD",
        compare_at_price_currency: "USD",
        quantity_price_breaks: [],
      },
      {
        id: 47259473444916,
        product_id: 8695485956148,
        title: "925 Sterling Silver / Aphrodite / 20-22",
        price: "155.00",
        sku: "N-1008447",
        position: 18,
        compare_at_price: "230.00",
        fulfillment_service: "manual",
        inventory_management: "shopify",
        option1: "925 Sterling Silver",
        option2: "Aphrodite",
        option3: "20-22",
        created_at: "2025-11-14T19:22:09-08:00",
        updated_at: "2025-11-26T14:25:41-08:00",
        taxable: true,
        barcode: "",
        grams: 0,
        image_id: 36020710309940,
        weight: 0.0,
        weight_unit: "kg",
        requires_shipping: true,
        quantity_rule: { min: 1, max: null, increment: 1 },
        price_currency: "USD",
        compare_at_price_currency: "USD",
        quantity_price_breaks: [],
      },
      {
        id: 47259473477684,
        product_id: 8695485956148,
        title: "925 Sterling Silver / Persephone / 16-18",
        price: "150.00",
        sku: "N-1008474",
        position: 19,
        compare_at_price: "220.00",
        fulfillment_service: "manual",
        inventory_management: "shopify",
        option1: "925 Sterling Silver",
        option2: "Persephone",
        option3: "16-18",
        created_at: "2025-11-14T19:22:10-08:00",
        updated_at: "2025-11-26T14:25:41-08:00",
        taxable: true,
        barcode: "",
        grams: 0,
        image_id: 36020493844532,
        weight: 0.0,
        weight_unit: "kg",
        requires_shipping: true,
        quantity_rule: { min: 1, max: null, increment: 1 },
        price_currency: "USD",
        compare_at_price_currency: "USD",
        quantity_price_breaks: [],
      },
      {
        id: 47259473510452,
        product_id: 8695485956148,
        title: "925 Sterling Silver / Persephone / 20-22",
        price: "155.00",
        sku: "N-1008475",
        position: 20,
        compare_at_price: "230.00",
        fulfillment_service: "manual",
        inventory_management: "shopify",
        option1: "925 Sterling Silver",
        option2: "Persephone",
        option3: "20-22",
        created_at: "2025-11-14T19:22:11-08:00",
        updated_at: "2025-11-26T14:25:41-08:00",
        taxable: true,
        barcode: "",
        grams: 0,
        image_id: 36020493844532,
        weight: 0.0,
        weight_unit: "kg",
        requires_shipping: true,
        quantity_rule: { min: 1, max: null, increment: 1 },
        price_currency: "USD",
        compare_at_price_currency: "USD",
        quantity_price_breaks: [],
      },
      {
        id: 47259474001972,
        product_id: 8695485956148,
        title: "14K Gold Vermeil / Rhiannon / 16-18",
        price: "170.00",
        sku: "N-1008476",
        position: 21,
        compare_at_price: "250.00",
        fulfillment_service: "manual",
        inventory_management: "shopify",
        option1: "14K Gold Vermeil",
        option2: "Rhiannon",
        option3: "16-18",
        created_at: "2025-11-14T19:22:27-08:00",
        updated_at: "2025-11-26T14:25:41-08:00",
        taxable: true,
        barcode: "",
        grams: 0,
        image_id: 36020717420596,
        weight: 0.0,
        weight_unit: "kg",
        requires_shipping: true,
        quantity_rule: { min: 1, max: null, increment: 1 },
        price_currency: "USD",
        compare_at_price_currency: "USD",
        quantity_price_breaks: [],
      },
      {
        id: 47259474067508,
        product_id: 8695485956148,
        title: "14K Gold Vermeil / Rhiannon / 20-22",
        price: "175.00",
        sku: "N-1008477",
        position: 22,
        compare_at_price: "260.00",
        fulfillment_service: "manual",
        inventory_management: "shopify",
        option1: "14K Gold Vermeil",
        option2: "Rhiannon",
        option3: "20-22",
        created_at: "2025-11-14T19:22:28-08:00",
        updated_at: "2025-11-26T14:25:41-08:00",
        taxable: true,
        barcode: "",
        grams: 0,
        image_id: 36020717420596,
        weight: 0.0,
        weight_unit: "kg",
        requires_shipping: true,
        quantity_rule: { min: 1, max: null, increment: 1 },
        price_currency: "USD",
        compare_at_price_currency: "USD",
        quantity_price_breaks: [],
      },
      {
        id: 47259473543220,
        product_id: 8695485956148,
        title: "14K Gold Vermeil / Freya / 16-18",
        price: "170.00",
        sku: "N-1008456",
        position: 23,
        compare_at_price: "250.00",
        fulfillment_service: "manual",
        inventory_management: "shopify",
        option1: "14K Gold Vermeil",
        option2: "Freya",
        option3: "16-18",
        created_at: "2025-11-14T19:22:12-08:00",
        updated_at: "2025-11-26T14:25:41-08:00",
        taxable: true,
        barcode: "",
        grams: 0,
        image_id: 36028507160628,
        weight: 0.0,
        weight_unit: "kg",
        requires_shipping: true,
        quantity_rule: { min: 1, max: null, increment: 1 },
        price_currency: "USD",
        compare_at_price_currency: "USD",
        quantity_price_breaks: [],
      },
      {
        id: 47259473575988,
        product_id: 8695485956148,
        title: "14K Gold Vermeil / Freya / 20-22",
        price: "175.00",
        sku: "N-1008457",
        position: 24,
        compare_at_price: "260.00",
        fulfillment_service: "manual",
        inventory_management: "shopify",
        option1: "14K Gold Vermeil",
        option2: "Freya",
        option3: "20-22",
        created_at: "2025-11-14T19:22:13-08:00",
        updated_at: "2025-11-26T14:25:41-08:00",
        taxable: true,
        barcode: "",
        grams: 0,
        image_id: 36028507160628,
        weight: 0.0,
        weight_unit: "kg",
        requires_shipping: true,
        quantity_rule: { min: 1, max: null, increment: 1 },
        price_currency: "USD",
        compare_at_price_currency: "USD",
        quantity_price_breaks: [],
      },
      {
        id: 47259473608756,
        product_id: 8695485956148,
        title: "14K Gold Vermeil / Athena / 16-18",
        price: "170.00",
        sku: "N-1008452",
        position: 25,
        compare_at_price: "250.00",
        fulfillment_service: "manual",
        inventory_management: "shopify",
        option1: "14K Gold Vermeil",
        option2: "Athena",
        option3: "16-18",
        created_at: "2025-11-14T19:22:14-08:00",
        updated_at: "2025-11-26T14:25:41-08:00",
        taxable: true,
        barcode: "",
        grams: 0,
        image_id: 36020712439860,
        weight: 0.0,
        weight_unit: "kg",
        requires_shipping: true,
        quantity_rule: { min: 1, max: null, increment: 1 },
        price_currency: "USD",
        compare_at_price_currency: "USD",
        quantity_price_breaks: [],
      },
      {
        id: 47259473641524,
        product_id: 8695485956148,
        title: "14K Gold Vermeil / Athena / 20-22",
        price: "175.00",
        sku: "N-1008453",
        position: 26,
        compare_at_price: "260.00",
        fulfillment_service: "manual",
        inventory_management: "shopify",
        option1: "14K Gold Vermeil",
        option2: "Athena",
        option3: "20-22",
        created_at: "2025-11-14T19:22:15-08:00",
        updated_at: "2025-11-26T14:25:41-08:00",
        taxable: true,
        barcode: "",
        grams: 0,
        image_id: 36020712439860,
        weight: 0.0,
        weight_unit: "kg",
        requires_shipping: true,
        quantity_rule: { min: 1, max: null, increment: 1 },
        price_currency: "USD",
        compare_at_price_currency: "USD",
        quantity_price_breaks: [],
      },
      {
        id: 47259473674292,
        product_id: 8695485956148,
        title: "14K Gold Vermeil / Hecate / 16-18",
        price: "170.00",
        sku: "N-1008460",
        position: 27,
        compare_at_price: "250.00",
        fulfillment_service: "manual",
        inventory_management: "shopify",
        option1: "14K Gold Vermeil",
        option2: "Hecate",
        option3: "16-18",
        created_at: "2025-11-14T19:22:16-08:00",
        updated_at: "2025-11-26T14:25:41-08:00",
        taxable: true,
        barcode: "",
        grams: 0,
        image_id: 36020714766388,
        weight: 0.0,
        weight_unit: "kg",
        requires_shipping: true,
        quantity_rule: { min: 1, max: null, increment: 1 },
        price_currency: "USD",
        compare_at_price_currency: "USD",
        quantity_price_breaks: [],
      },
      {
        id: 47259473707060,
        product_id: 8695485956148,
        title: "14K Gold Vermeil / Hecate / 20-22",
        price: "175.00",
        sku: "N-1008461",
        position: 28,
        compare_at_price: "260.00",
        fulfillment_service: "manual",
        inventory_management: "shopify",
        option1: "14K Gold Vermeil",
        option2: "Hecate",
        option3: "20-22",
        created_at: "2025-11-14T19:22:17-08:00",
        updated_at: "2025-11-26T14:25:41-08:00",
        taxable: true,
        barcode: "",
        grams: 0,
        image_id: 36020714766388,
        weight: 0.0,
        weight_unit: "kg",
        requires_shipping: true,
        quantity_rule: { min: 1, max: null, increment: 1 },
        price_currency: "USD",
        compare_at_price_currency: "USD",
        quantity_price_breaks: [],
      },
      {
        id: 47259473739828,
        product_id: 8695485956148,
        title: "14K Gold Vermeil / Lilith / 16-18",
        price: "170.00",
        sku: "N-1008462",
        position: 29,
        compare_at_price: "250.00",
        fulfillment_service: "manual",
        inventory_management: "shopify",
        option1: "14K Gold Vermeil",
        option2: "Lilith",
        option3: "16-18",
        created_at: "2025-11-14T19:22:18-08:00",
        updated_at: "2025-11-26T14:25:41-08:00",
        taxable: true,
        barcode: "",
        grams: 0,
        image_id: 36020479983668,
        weight: 0.0,
        weight_unit: "kg",
        requires_shipping: true,
        quantity_rule: { min: 1, max: null, increment: 1 },
        price_currency: "USD",
        compare_at_price_currency: "USD",
        quantity_price_breaks: [],
      },
      {
        id: 47259473772596,
        product_id: 8695485956148,
        title: "14K Gold Vermeil / Lilith / 20-22",
        price: "175.00",
        sku: "N-1008465",
        position: 30,
        compare_at_price: "260.00",
        fulfillment_service: "manual",
        inventory_management: "shopify",
        option1: "14K Gold Vermeil",
        option2: "Lilith",
        option3: "20-22",
        created_at: "2025-11-14T19:22:19-08:00",
        updated_at: "2025-11-26T14:25:41-08:00",
        taxable: true,
        barcode: "",
        grams: 0,
        image_id: 36020479983668,
        weight: 0.0,
        weight_unit: "kg",
        requires_shipping: true,
        quantity_rule: { min: 1, max: null, increment: 1 },
        price_currency: "USD",
        compare_at_price_currency: "USD",
        quantity_price_breaks: [],
      },
      {
        id: 47259473805364,
        product_id: 8695485956148,
        title: "14K Gold Vermeil / Medusa / 16-18",
        price: "170.00",
        sku: "N-1008468",
        position: 31,
        compare_at_price: "250.00",
        fulfillment_service: "manual",
        inventory_management: "shopify",
        option1: "14K Gold Vermeil",
        option2: "Medusa",
        option3: "16-18",
        created_at: "2025-11-14T19:22:20-08:00",
        updated_at: "2025-11-26T14:25:41-08:00",
        taxable: true,
        barcode: "",
        grams: 0,
        image_id: 36020493058100,
        weight: 0.0,
        weight_unit: "kg",
        requires_shipping: true,
        quantity_rule: { min: 1, max: null, increment: 1 },
        price_currency: "USD",
        compare_at_price_currency: "USD",
        quantity_price_breaks: [],
      },
      {
        id: 47259473838132,
        product_id: 8695485956148,
        title: "14K Gold Vermeil / Medusa / 20-22",
        price: "175.00",
        sku: "N-1008469",
        position: 32,
        compare_at_price: "260.00",
        fulfillment_service: "manual",
        inventory_management: "shopify",
        option1: "14K Gold Vermeil",
        option2: "Medusa",
        option3: "20-22",
        created_at: "2025-11-14T19:22:21-08:00",
        updated_at: "2025-11-26T14:25:41-08:00",
        taxable: true,
        barcode: "",
        grams: 0,
        image_id: 36020493058100,
        weight: 0.0,
        weight_unit: "kg",
        requires_shipping: true,
        quantity_rule: { min: 1, max: null, increment: 1 },
        price_currency: "USD",
        compare_at_price_currency: "USD",
        quantity_price_breaks: [],
      },
      {
        id: 47259473870900,
        product_id: 8695485956148,
        title: "14K Gold Vermeil / Selene / 16-18",
        price: "170.00",
        sku: "N-1008480",
        position: 33,
        compare_at_price: "250.00",
        fulfillment_service: "manual",
        inventory_management: "shopify",
        option1: "14K Gold Vermeil",
        option2: "Selene",
        option3: "16-18",
        created_at: "2025-11-14T19:22:22-08:00",
        updated_at: "2025-11-26T14:25:41-08:00",
        taxable: true,
        barcode: "",
        grams: 0,
        image_id: 36020494401588,
        weight: 0.0,
        weight_unit: "kg",
        requires_shipping: true,
        quantity_rule: { min: 1, max: null, increment: 1 },
        price_currency: "USD",
        compare_at_price_currency: "USD",
        quantity_price_breaks: [],
      },
      {
        id: 47259473903668,
        product_id: 8695485956148,
        title: "14K Gold Vermeil / Selene / 20-22",
        price: "175.00",
        sku: "N-1008481",
        position: 34,
        compare_at_price: "260.00",
        fulfillment_service: "manual",
        inventory_management: "shopify",
        option1: "14K Gold Vermeil",
        option2: "Selene",
        option3: "20-22",
        created_at: "2025-11-14T19:22:23-08:00",
        updated_at: "2025-11-26T14:25:41-08:00",
        taxable: true,
        barcode: "",
        grams: 0,
        image_id: 36020494401588,
        weight: 0.0,
        weight_unit: "kg",
        requires_shipping: true,
        quantity_rule: { min: 1, max: null, increment: 1 },
        price_currency: "USD",
        compare_at_price_currency: "USD",
        quantity_price_breaks: [],
      },
      {
        id: 47259473936436,
        product_id: 8695485956148,
        title: "14K Gold Vermeil / Artemis / 16-18",
        price: "170.00",
        sku: "N-1008448",
        position: 35,
        compare_at_price: "250.00",
        fulfillment_service: "manual",
        inventory_management: "shopify",
        option1: "14K Gold Vermeil",
        option2: "Artemis",
        option3: "16-18",
        created_at: "2025-11-14T19:22:25-08:00",
        updated_at: "2025-11-26T14:25:41-08:00",
        taxable: true,
        barcode: "",
        grams: 0,
        image_id: 36020461699124,
        weight: 0.0,
        weight_unit: "kg",
        requires_shipping: true,
        quantity_rule: { min: 1, max: null, increment: 1 },
        price_currency: "USD",
        compare_at_price_currency: "USD",
        quantity_price_breaks: [],
      },
      {
        id: 47259473969204,
        product_id: 8695485956148,
        title: "14K Gold Vermeil / Artemis / 20-22",
        price: "175.00",
        sku: "N-1008449",
        position: 36,
        compare_at_price: "260.00",
        fulfillment_service: "manual",
        inventory_management: "shopify",
        option1: "14K Gold Vermeil",
        option2: "Artemis",
        option3: "20-22",
        created_at: "2025-11-14T19:22:26-08:00",
        updated_at: "2025-11-26T14:25:41-08:00",
        taxable: true,
        barcode: "",
        grams: 0,
        image_id: 36020461699124,
        weight: 0.0,
        weight_unit: "kg",
        requires_shipping: true,
        quantity_rule: { min: 1, max: null, increment: 1 },
        price_currency: "USD",
        compare_at_price_currency: "USD",
        quantity_price_breaks: [],
      },
      {
        id: 47259474133044,
        product_id: 8695485956148,
        title: "14K Gold Vermeil / Aphrodite / 16-18",
        price: "170.00",
        sku: "N-1008444",
        position: 37,
        compare_at_price: "250.00",
        fulfillment_service: "manual",
        inventory_management: "shopify",
        option1: "14K Gold Vermeil",
        option2: "Aphrodite",
        option3: "16-18",
        created_at: "2025-11-14T19:22:29-08:00",
        updated_at: "2025-11-26T14:25:41-08:00",
        taxable: true,
        barcode: "",
        grams: 0,
        image_id: 36020711915572,
        weight: 0.0,
        weight_unit: "kg",
        requires_shipping: true,
        quantity_rule: { min: 1, max: null, increment: 1 },
        price_currency: "USD",
        compare_at_price_currency: "USD",
        quantity_price_breaks: [],
      },
      {
        id: 47259474165812,
        product_id: 8695485956148,
        title: "14K Gold Vermeil / Aphrodite / 20-22",
        price: "175.00",
        sku: "N-1008445",
        position: 38,
        compare_at_price: "260.00",
        fulfillment_service: "manual",
        inventory_management: "shopify",
        option1: "14K Gold Vermeil",
        option2: "Aphrodite",
        option3: "20-22",
        created_at: "2025-11-14T19:22:31-08:00",
        updated_at: "2025-11-26T14:25:41-08:00",
        taxable: true,
        barcode: "",
        grams: 0,
        image_id: 36020711915572,
        weight: 0.0,
        weight_unit: "kg",
        requires_shipping: true,
        quantity_rule: { min: 1, max: null, increment: 1 },
        price_currency: "USD",
        compare_at_price_currency: "USD",
        quantity_price_breaks: [],
      },
      {
        id: 47259474198580,
        product_id: 8695485956148,
        title: "14K Gold Vermeil / Persephone / 16-18",
        price: "170.00",
        sku: "N-1008472",
        position: 39,
        compare_at_price: "250.00",
        fulfillment_service: "manual",
        inventory_management: "shopify",
        option1: "14K Gold Vermeil",
        option2: "Persephone",
        option3: "16-18",
        created_at: "2025-11-14T19:22:32-08:00",
        updated_at: "2025-11-26T14:25:41-08:00",
        taxable: true,
        barcode: "",
        grams: 0,
        image_id: 36020493811764,
        weight: 0.0,
        weight_unit: "kg",
        requires_shipping: true,
        quantity_rule: { min: 1, max: null, increment: 1 },
        price_currency: "USD",
        compare_at_price_currency: "USD",
        quantity_price_breaks: [],
      },
      {
        id: 47259474264116,
        product_id: 8695485956148,
        title: "14K Gold Vermeil / Persephone / 20-22",
        price: "175.00",
        sku: "N-1008473",
        position: 40,
        compare_at_price: "260.00",
        fulfillment_service: "manual",
        inventory_management: "shopify",
        option1: "14K Gold Vermeil",
        option2: "Persephone",
        option3: "20-22",
        created_at: "2025-11-14T19:22:33-08:00",
        updated_at: "2025-11-26T14:25:41-08:00",
        taxable: true,
        barcode: "",
        grams: 0,
        image_id: 36020493811764,
        weight: 0.0,
        weight_unit: "kg",
        requires_shipping: true,
        quantity_rule: { min: 1, max: null, increment: 1 },
        price_currency: "USD",
        compare_at_price_currency: "USD",
        quantity_price_breaks: [],
      },
    ],
    options: [
      {
        id: 10816749633588,
        product_id: 8695485956148,
        name: "Material",
        position: 1,
        values: ["925 Sterling Silver", "14K Gold Vermeil"],
      },
      {
        id: 10816749666356,
        product_id: 8695485956148,
        name: "Goddess",
        position: 2,
        values: [
          "Rhiannon",
          "Freya",
          "Athena",
          "Hecate",
          "Lilith",
          "Medusa",
          "Selene",
          "Artemis",
          "Aphrodite",
          "Persephone",
        ],
      },
      {
        id: 10816749699124,
        product_id: 8695485956148,
        name: "Length",
        position: 3,
        values: ["16-18", "20-22"],
      },
    ],
    images: [
      {
        id: 36020705853492,
        product_id: 8695485956148,
        position: 1,
        created_at: "2025-11-17T14:45:05-08:00",
        updated_at: "2025-11-19T19:28:58-08:00",
        alt: "Awe Inspired Necklaces 14K Yellow Gold Vermeil / Rhiannon / 16-18 Goddess Coin Necklace",
        width: 2500,
        height: 2443,
        src: "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-14k-yellow-gold-vermeil-rhiannon-16-18-goddess-coin-necklace-1205682192.webp?v=1763609338",
        variant_ids: [],
      },
      {
        id: 36009903161396,
        product_id: 8695485956148,
        position: 2,
        created_at: "2025-11-14T16:22:59-08:00",
        updated_at: "2025-11-19T19:28:58-08:00",
        alt: "Awe Inspired Pendants Standard 20mm Goddess Reworks",
        width: 2500,
        height: 2500,
        src: "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-pendants-standard-20mm-goddess-reworks-1204974226.webp?v=1763609338",
        variant_ids: [],
      },
      {
        id: 36022680322100,
        product_id: 8695485956148,
        position: 3,
        created_at: "2025-11-18T11:00:32-08:00",
        updated_at: "2025-11-20T14:25:51-08:00",
        alt: "Awe Inspired Pendants Goddess Pendant",
        width: 2500,
        height: 2500,
        src: "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/goddess-pendant-grid.webp?v=1763677551",
        variant_ids: [],
      },
      {
        id: 36020747141172,
        product_id: 8695485956148,
        position: 4,
        created_at: "2025-11-17T15:25:50-08:00",
        updated_at: "2025-11-20T14:25:51-08:00",
        alt: "Awe Inspired Pendants Mini Goddess Coin Pendant",
        width: 2500,
        height: 2500,
        src: "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-pendants-mini-goddess-coin-pendant-1205682151.webp?v=1763677551",
        variant_ids: [],
      },
      {
        id: 36020461731892,
        product_id: 8695485956148,
        position: 5,
        created_at: "2025-11-17T12:15:25-08:00",
        updated_at: "2025-11-19T19:59:19-08:00",
        alt: "Awe Inspired Necklaces 925 Sterling Silver / Artemis / 16-18 Standard Goddess Necklace Reworks",
        width: 2500,
        height: 2443,
        src: "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-925-sterling-silver-artemis-16-18-standard-goddess-necklace-reworks-1205463566.webp?v=1763611159",
        variant_ids: [47259473281076, 47259473313844],
      },
      {
        id: 36020479950900,
        product_id: 8695485956148,
        position: 6,
        created_at: "2025-11-17T12:35:02-08:00",
        updated_at: "2025-11-19T19:59:19-08:00",
        alt: "Awe Inspired Necklaces 925 Sterling Silver / Lilith / 16-18 Standard Goddess Necklace Reworks",
        width: 2500,
        height: 2442,
        src: "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-925-sterling-silver-lilith-16-18-standard-goddess-necklace-reworks-1205653078.webp?v=1763611159",
        variant_ids: [47259473084468, 47259473117236],
      },
      {
        id: 36020479983668,
        product_id: 8695485956148,
        position: 7,
        created_at: "2025-11-17T12:35:05-08:00",
        updated_at: "2025-11-19T19:59:19-08:00",
        alt: "Awe Inspired Necklaces 14K Yellow Gold Vermeil / Lilith / 16-18 Standard Goddess Necklace Reworks",
        width: 2500,
        height: 2442,
        src: "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-14k-yellow-gold-vermeil-lilith-16-18-standard-goddess-necklace-reworks-1205653077.webp?v=1763611159",
        variant_ids: [47259473739828, 47259473772596],
      },
      {
        id: 36020493058100,
        product_id: 8695485956148,
        position: 8,
        created_at: "2025-11-17T12:48:13-08:00",
        updated_at: "2025-11-19T19:59:19-08:00",
        alt: "Awe Inspired Necklaces 14K Yellow Gold Vermeil / Medusa / 16-18 Standard Goddess Necklace Reworks",
        width: 2500,
        height: 2443,
        src: "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-14k-yellow-gold-vermeil-medusa-16-18-standard-goddess-necklace-reworks-1205653076.webp?v=1763611159",
        variant_ids: [47259473805364, 47259473838132],
      },
      {
        id: 36020493123636,
        product_id: 8695485956148,
        position: 9,
        created_at: "2025-11-17T12:48:15-08:00",
        updated_at: "2025-11-19T19:59:19-08:00",
        alt: "Awe Inspired Necklaces 925 Sterling Silver / Medusa / 16-18 Standard Goddess Necklace Reworks",
        width: 2500,
        height: 2443,
        src: "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-925-sterling-silver-medusa-16-18-standard-goddess-necklace-reworks-1205653075.webp?v=1763611159",
        variant_ids: [47259473150004, 47259473182772],
      },
      {
        id: 36020493811764,
        product_id: 8695485956148,
        position: 10,
        created_at: "2025-11-17T12:50:08-08:00",
        updated_at: "2025-11-19T19:59:19-08:00",
        alt: "Awe Inspired Necklaces 14K Yellow Gold Vermeil / Persephone / 16-18 Standard Goddess Necklace Reworks",
        width: 2500,
        height: 2442,
        src: "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-14k-yellow-gold-vermeil-persephone-16-18-standard-goddess-necklace-reworks-1205653074.webp?v=1763611159",
        variant_ids: [47259474198580, 47259474264116],
      },
      {
        id: 36020493844532,
        product_id: 8695485956148,
        position: 11,
        created_at: "2025-11-17T12:50:10-08:00",
        updated_at: "2025-11-19T19:59:19-08:00",
        alt: "Awe Inspired Necklaces 925 Sterling Silver / Persephone / 16-18 Standard Goddess Necklace Reworks",
        width: 2500,
        height: 2442,
        src: "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-925-sterling-silver-persephone-16-18-standard-goddess-necklace-reworks-1205653073.webp?v=1763611159",
        variant_ids: [47259473477684, 47259473510452],
      },
      {
        id: 36020494401588,
        product_id: 8695485956148,
        position: 12,
        created_at: "2025-11-17T12:52:00-08:00",
        updated_at: "2025-11-19T19:59:19-08:00",
        alt: "Awe Inspired Necklaces 14K Yellow Gold Vermeil / Selene / 16-18 Standard Goddess Necklace Reworks",
        width: 2500,
        height: 2443,
        src: "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-14k-yellow-gold-vermeil-selene-16-18-standard-goddess-necklace-reworks-1205653072.webp?v=1763611159",
        variant_ids: [47259473870900, 47259473903668],
      },
      {
        id: 36020494434356,
        product_id: 8695485956148,
        position: 13,
        created_at: "2025-11-17T12:52:02-08:00",
        updated_at: "2025-11-19T19:59:19-08:00",
        alt: "Awe Inspired Necklaces 925 Sterling Silver / Selene / 16-18 Standard Goddess Necklace Reworks",
        width: 2500,
        height: 2443,
        src: "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-925-sterling-silver-selene-16-18-standard-goddess-necklace-reworks-1205653071.webp?v=1763611159",
        variant_ids: [47259473215540, 47259473248308],
      },
      {
        id: 36020461699124,
        product_id: 8695485956148,
        position: 14,
        created_at: "2025-11-17T12:15:23-08:00",
        updated_at: "2025-11-19T19:59:19-08:00",
        alt: "Awe Inspired Necklaces 14K Yellow Gold Vermeil / Artemis / 16-18 Standard Goddess Necklace Reworks",
        width: 2500,
        height: 2443,
        src: "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-14k-yellow-gold-vermeil-artemis-16-18-standard-goddess-necklace-reworks-1205463567.webp?v=1763611159",
        variant_ids: [47259473936436, 47259473969204],
      },
      {
        id: 36020710309940,
        product_id: 8695485956148,
        position: 15,
        created_at: "2025-11-17T14:50:08-08:00",
        updated_at: "2025-11-19T19:59:19-08:00",
        alt: "Awe Inspired Necklaces 925 Sterling Silver / Aphrodite / 16-18 Goddess Coin Necklace",
        width: 2500,
        height: 2443,
        src: "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-925-sterling-silver-aphrodite-16-18-goddess-coin-necklace-1205682190.webp?v=1763611159",
        variant_ids: [47259473412148, 47259473444916],
      },
      {
        id: 36020711915572,
        product_id: 8695485956148,
        position: 16,
        created_at: "2025-11-17T14:50:59-08:00",
        updated_at: "2025-11-19T19:59:19-08:00",
        alt: "Awe Inspired Necklaces 14K Yellow Gold Vermeil / Aphrodite / 16-18 Goddess Coin Necklace",
        width: 2500,
        height: 2443,
        src: "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-14k-yellow-gold-vermeil-aphrodite-16-18-goddess-coin-necklace-1205682189.webp?v=1763611159",
        variant_ids: [47259474133044, 47259474165812],
      },
      {
        id: 36020712439860,
        product_id: 8695485956148,
        position: 17,
        created_at: "2025-11-17T14:52:09-08:00",
        updated_at: "2025-11-19T19:59:19-08:00",
        alt: "Awe Inspired Necklaces 14K Yellow Gold Vermeil / Athena / 16-18 Goddess Coin Necklace",
        width: 2500,
        height: 2443,
        src: "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-14k-yellow-gold-vermeil-athena-16-18-goddess-coin-necklace-1205682188.webp?v=1763611159",
        variant_ids: [47259473608756, 47259473641524],
      },
      {
        id: 36020712472628,
        product_id: 8695485956148,
        position: 18,
        created_at: "2025-11-17T14:52:12-08:00",
        updated_at: "2025-11-19T19:59:19-08:00",
        alt: "Awe Inspired Necklaces 925 Sterling Silver / Athena / 16-18 Goddess Coin Necklace",
        width: 2500,
        height: 2443,
        src: "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-925-sterling-silver-athena-16-18-goddess-coin-necklace-1205682187.webp?v=1763611159",
        variant_ids: [47259472953396, 47259472986164],
      },
      {
        id: 36020714766388,
        product_id: 8695485956148,
        position: 19,
        created_at: "2025-11-17T14:54:05-08:00",
        updated_at: "2025-11-19T19:59:19-08:00",
        alt: "Awe Inspired Necklaces 14K Yellow Gold Vermeil / Hecate / 16-18 Goddess Coin Necklace",
        width: 2500,
        height: 2443,
        src: "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-14k-yellow-gold-vermeil-hecate-16-18-goddess-coin-necklace-1205682186.webp?v=1763611159",
        variant_ids: [47259473674292, 47259473707060],
      },
      {
        id: 36020715126836,
        product_id: 8695485956148,
        position: 20,
        created_at: "2025-11-17T14:54:09-08:00",
        updated_at: "2025-11-19T19:59:19-08:00",
        alt: "Awe Inspired Necklaces 925 Sterling Silver / Hecate / 16-18 Goddess Coin Necklace",
        width: 2500,
        height: 2443,
        src: "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-925-sterling-silver-hecate-16-18-goddess-coin-necklace-1205682185.webp?v=1763611159",
        variant_ids: [47259473018932, 47259473051700],
      },
      {
        id: 36020717420596,
        product_id: 8695485956148,
        position: 21,
        created_at: "2025-11-17T14:56:15-08:00",
        updated_at: "2025-11-19T19:59:19-08:00",
        alt: "Awe Inspired Necklaces 14K Yellow Gold Vermeil / Rhiannon / 16-18 Goddess Coin Necklace",
        width: 2500,
        height: 2443,
        src: "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-14k-yellow-gold-vermeil-rhiannon-16-18-goddess-coin-necklace-1205682184.webp?v=1763611159",
        variant_ids: [47259474001972, 47259474067508],
      },
      {
        id: 36020717453364,
        product_id: 8695485956148,
        position: 22,
        created_at: "2025-11-17T14:56:17-08:00",
        updated_at: "2025-11-19T19:59:19-08:00",
        alt: "Awe Inspired Necklaces 925 Sterling Silver / Rhiannon / 16-18 Goddess Coin Necklace",
        width: 2500,
        height: 2443,
        src: "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-925-sterling-silver-rhiannon-16-18-goddess-coin-necklace-1205682183.webp?v=1763611159",
        variant_ids: [47259473346612, 47259473379380],
      },
      {
        id: 36028501819444,
        product_id: 8695485956148,
        position: 23,
        created_at: "2025-11-19T20:10:32-08:00",
        updated_at: "2025-11-19T21:25:39-08:00",
        alt: "Awe Inspired Necklaces 925 Sterling Silver / Freya / 16-18 Goddess Necklace",
        width: 2500,
        height: 2443,
        src: "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-925-sterling-silver-freya-16-18-goddess-necklace-1207659175.webp?v=1763616339",
        variant_ids: [47259472887860, 47259472920628],
      },
      {
        id: 36028507160628,
        product_id: 8695485956148,
        position: 24,
        created_at: "2025-11-19T20:12:00-08:00",
        updated_at: "2025-11-19T21:25:43-08:00",
        alt: "Awe Inspired Necklaces 14K Gold Vermeil / Freya / 16-18 Goddess Necklace",
        width: 2500,
        height: 2443,
        src: "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-14k-gold-vermeil-freya-16-18-goddess-necklace-1207659174.webp?v=1763616343",
        variant_ids: [47259473543220, 47259473575988],
      },
    ],
  },
};

const GODDESS_META_DATA = {
  Aphrodite: {
    image:
      "https://aweinspired.com/cdn/shop/t/416/assets/aphrodite-goddess.png",
    title: "Aphrodite",
    desc: "Goddess of love, beauty and confidence, Aphrodite lights hearts aflame. Even the king of gods can be put under her spell.",
    quote_inner:
      "Joyful, kind, a true romantic. You are light hearted, love to laugh, and can be known to cause a little mischief.",
    quote_outer:
      "You are charming, graceful, and a radiant beauty. You have a gentle, magnetizing energy about you.",
    product_desc: "Greek Goddess of love",
  },
  Athena: {
    image: "https://aweinspired.com/cdn/shop/t/416/assets/athena-goddess.png",
    title: "Athena",
    desc: "Athena is known for her military prowess, quick wit, deep love of learning and unrelenting courage in battle.",
    quote_inner:
      "Rational, strong, and always in pursuit of greatness. You have internal wisdom that guides your decision making.",
    quote_outer:
      "Well-educated, well-read, well-spoken. Others listen when you speak because you have the wisdom to back up your confidence.",
    product_desc: "Greek Goddess of war and wisdom",
  },
  Freya: {
    image: "https://aweinspired.com/cdn/shop/t/416/assets/freya-goddess.png",
    title: "Freya",
    desc: "Incredibly charming and spirited, Freya loves the finer things, always blessing those around her with love and abundance.",
    quote_inner:
      "Driven by passion and pleasure, you aren’t afraid to take what you want, but you always give back.",
    quote_outer:
      "People are attracted to your passionate aura, and they’re always better off when they’re around you - especially lovers.",
    product_desc: "Norse Goddess of love and fertility",
  },
  Hecate: {
    image: "https://aweinspired.com/cdn/shop/t/416/assets/hecate-goddess.png",
    title: "Hecate",
    desc: "Ancient and powerful Hecate presides over witchcraft, ghosts, and transformation with a mysterious dark magic.",
    quote_inner:
      "Fiercely independent with a black sense of humor, you find magic in darkness and come alive in your own company.",
    quote_outer:
      "You project power, intensity and uncommon knowledge. Your mystery is magnetic, though you prefer to work alone.",
    product_desc: "Greek Goddess of witchcraft",
  },
  Lilith: {
    image: "https://aweinspired.com/cdn/shop/t/416/assets/lilith-goddess.png",
    title: "Lilith",
    desc: "A Goddess of female liberation and power, Lilith was banished from the Garden of Eden for refusing to submit to a man.",
    quote_inner:
      "Highly intuitive, you have powerful dreams, dark desires and are unafraid to study your shadowy depths.",
    quote_outer:
      "Charming, yet ruthless. You put the ‘fatale’ in femme fatale. Others are obsessed with you but you’re unbothered.",
    product_desc: "Embrace the fall",
  },
  Medusa: {
    image: "https://aweinspired.com/cdn/shop/t/416/assets/medusa-goddess.png",
    title: "Medusa",
    desc: "A deeply protective symbol, the face of Goddess Medusa represents feminine resilience and strength.",
    quote_inner:
      "Resilient and independent, you are wholly self-possessed, having learned long ago to not care what others think.",
    quote_outer:
      "Self-possessed and fiercely opinionated, you’re never afraid to stand up for yourself and other women.",
    product_desc: "Goddess who can turn men to stone",
  },
  Persephone: {
    image:
      "https://aweinspired.com/cdn/shop/t/416/assets/persephone-goddess.png",
    title: "Persephone",
    desc: "Dual Goddess of springtime and Queen of the underworld, Persephone walks the line between life and death.",
    quote_inner:
      "Blooming with vitality, you have a fearless heart and balance your sunny outlook with your darker depths.",
    quote_outer:
      "You’re cherished by those around you for your sweet, sunny outlook, balanced by your ability to embrace darkness.",
    product_desc: "Greek Goddess of springtime",
  },
  Selene: {
    image: "https://aweinspired.com/cdn/shop/t/416/assets/selene-goddess.png",
    title: "Selene",
    desc: "With her mesmerizing radiance, Selene is the lovely and bright Queen of the Night, muse of all poets and lovers.",
    quote_inner:
      "Your inner radiance makes you completely mesmerizing, making it impossible for others to get you off their minds.",
    quote_outer:
      "You mesmerize others with your brightness, radiant beauty and mysteriously alluring aura.",
    product_desc: "Greek Goddess of the moon",
  },
  Artemis: {
    image: "https://aweinspired.com/cdn/shop/t/416/assets/artemis-goddess.png",
    title: "Artemis",
    desc: "Goddess of the wilds, Artemis protects young women and animals, spending her days hunting in the forest with her huntresses.",
    quote_inner:
      "Protective, wild and a true girl’s girl, you find vitality and meaning in the beauty of mother nature.",
    quote_outer:
      "An environmentalist and adventurer, you love and protect all living beings from plants to animals to your dearest friends.",
    product_desc: "Greek Goddess of wild animals",
  },
  Rhiannon: {
    image: "https://aweinspired.com/cdn/shop/t/416/assets/rhiannon-goddess.png",
    title: "Rhiannon",
    desc: "With a gentle heart and a clever mind, Rhiannon rides a white horse and is always attended by fluttering birds.",
    quote_inner:
      "Keenly intelligent and bright as the sun, you’re happiest when spreading joy, warmth and help to everyone around you.",
    quote_outer:
      "Your smile always lights up the room. You’re the life of the party and people gravitate towards you to bask in your positive energy.",
    product_desc: "Welsh Goddess of horses and rebirth",
  },
};

function insertHardcodedGoddessProduct(goddessName, containerId) {
  try {
    const product = UNIFIED_GODDESS_DATA.product;

    const defaultMaterial = "14K Gold Vermeil";
    const defaultLength = "16-18";

    let variant = product.variants.find(
      (v) =>
        v.option2 === goddessName &&
        v.option1 === defaultMaterial &&
        v.option3 === defaultLength
    );

    if (!variant) {
      variant = product.variants.find((v) => v.option2 === goddessName);
    }

    if (!variant) {
      console.error(`No variant found for Goddess: ${goddessName}`);
      return;
    }

    const imageObj = product.images.find((img) => img.id === variant.image_id);
    // Use manually mapped metadata if available
    let metaImage = "";
    let metaDescription = "";
    let metaTitle = goddessName;
    let metaQuote = "";
    let metaProductDesc = "";

    if (GODDESS_META_DATA[goddessName]) {
      const meta = GODDESS_META_DATA[goddessName];
      metaImage = meta.image;
      metaDescription = meta.desc;
      metaTitle = meta.title;
      metaProductDesc = meta.product_desc || "";

      if (containerId === "inner_goddess_product") {
        metaQuote = meta.quote_inner;
      } else {
        metaQuote = meta.quote_outer;
      }
    } else {
      // Fallback logic if not in metadata map
      metaImage = imageObj
        ? imageObj.src
        : product.images[0]
        ? product.images[0].src
        : "";

      // Extract specific goddess description if available from body_html
      const parser = new DOMParser();
      const doc = parser.parseFromString(product.body_html, "text/html");
      const pTags = doc.querySelectorAll("p.p1");
      let specificDesc = "";
      for (const p of pTags) {
        if (p.textContent.includes(goddessName)) {
          specificDesc = p.innerHTML;
          break;
        }
      }
      if (!specificDesc) {
        const firstP = doc.querySelector("p");
        specificDesc = firstP ? firstP.innerHTML : "";
      }
      metaDescription = specificDesc;
      metaQuote = ""; // No fallback quote
    }

    // Unique ID for this instance to avoid conflicts
    const uniqueId = "hardcoded_goddess_" + containerId + "_" + Date.now();

    // Determine the title based on container ID
    let titleText = "Your Goddess";
    if (containerId === "outer_goddess_product") {
      titleText = "Your Outer Goddess";
    } else if (containerId === "inner_goddess_product") {
      titleText = "Your Inner Goddess";
    } else if (containerId === "IRL_goddess_product") {
      titleText = "Your IRL Goddess";
    }

    // Use variant image for the product display at the bottom
    const variantImage = imageObj
      ? imageObj.src
      : product.images[0]
      ? product.images[0].src
      : "";

    const html = `
      <div style="text-align: center; margin-bottom: 20px;">
          <div style="width: 120px; height: 120px; border-radius: 50%; overflow: hidden; margin: 0 auto 15px auto; border: 2px solid white;">
            <img src="${metaImage}" alt="${metaTitle}" style="width: 100%; height: 100%; object-fit: cover;">
          </div>
          <p style="font-size: 14px; margin-bottom: 5px; letter-spacing: 1px; text-transform: uppercase; color: white;">${titleText}</p>
          <h2 style="font-family: serif; font-size: 32px; margin-top: 0; color: white;">${metaTitle}</h2>
      </div>

      <div style="margin-bottom: 20px; min-height: 80px; color: white;">
          <p style="color: white;">${metaDescription}</p>
      </div>
      
      ${
        metaQuote
          ? `
      <div style="border-left: 3px solid #d4af37; padding-left: 15px; margin-bottom: 30px;">
        <p style="font-style: italic; font-size: 15px; line-height: 1.5; color: white;">${metaQuote}</p>
      </div>
      `
          : ""
      }

      <!-- Product Section -->
      <div style="display: flex; flex-direction: column; gap: 12px;">
        <!-- Full-width product image -->
        <div style="width: 100%; background: white; position: relative;">
          <img id="${uniqueId}_image" src="${variantImage}" alt="${
      variant.title
    }" style="width: 100%; height: auto; object-fit: contain;">
        </div>
        
        <!-- Material Icons and Length Row - using same structure as other products -->
        <div style="display: flex; justify-content: space-between; align-items: center; margin-top: 5px;">
          <!-- Material Icons - using tabnav structure like other products -->
          <ul class="tabnav" data-product-id="${uniqueId}" style="display: flex; gap: 8px; list-style: none; margin: 0; padding: 0;">
            <li><a href="javascript:void(0)" class="tab3" data-material="14K Gold Vermeil" onclick="updateHardcodedGoddessVariantFromTab(this, '${uniqueId}', '${goddessName}')"></a></li>
            <li><a href="javascript:void(0)" class="tab4" data-material="925 Sterling Silver" onclick="updateHardcodedGoddessVariantFromTab(this, '${uniqueId}', '${goddessName}')"></a></li>
          </ul>
          
          <!-- Length Dropdown -->
          <select id="${uniqueId}_length" class="dropdown" style="padding: 6px 12px; font-size: 13px; border-radius: 4px; background: white; border: 1px solid #ccc; color: #333;" onchange="updateHardcodedGoddessVariant('${uniqueId}', '${goddessName}')">
             <option value="16-18" ${
               variant.option3 === "16-18" ? "selected" : ""
             }>16"-18"</option>
             <option value="20-22" ${
               variant.option3 === "20-22" ? "selected" : ""
             }>20"-22"</option>
          </select>
        </div>
        
        <!-- Product name row -->
        <div style="display: flex; justify-content: space-between; align-items: center;">
          <p style="margin: 0; font-size: 14px; color: white;">${metaTitle} Necklace</p>
        </div>
        
        <!-- Description and Price row -->
        <div style="display: flex; justify-content: space-between; align-items: center;">
          <div style="font-size: 12px; color: white;">${metaProductDesc}</div>
          <div id="${uniqueId}_price" style="font-weight: bold; color: white; font-size: 18px;">$${
      variant.price
    }</div>
        </div>
        
        <!-- Hidden inputs -->
        <input type="hidden" id="${uniqueId}_material" value="${defaultMaterial}">
        <input type="hidden" id="${uniqueId}_variant" value="${variant.id}">

        <div class="awe__quiz_hero_cards_col_cta" style="margin-top: 10px;">
            <span id="${uniqueId}_cta" class="button1" style="width: 100%; text-align: center; display: block; padding: 12px; background: black; color: white; text-decoration: none; letter-spacing: 2px; font-size: 14px; cursor: pointer;" onclick="addUnifiedGoddessToCart('${uniqueId}')">ADD TO CART</span>
        </div>
      </div>
    `;

    const container = document.getElementById(containerId);
    if (container) {
      container.innerHTML = html;
      container.style.display = "block";
    } else {
      console.error(`Container '${containerId}' not found.`);
    }
  } catch (e) {
    console.error("Error inserting hardcoded Goddess product:", e);
  }
}

// Helper function to handle clicks from tabnav structure (like other products)
window.updateHardcodedGoddessVariantFromTab = function (
  element,
  uniqueId,
  goddessName
) {
  const selectedMaterial = element.getAttribute("data-material");
  window.updateHardcodedGoddessVariant(uniqueId, goddessName, selectedMaterial);
};

// Helper function to update the hardcoded product when dropdowns change
window.updateHardcodedGoddessVariant = function (
  uniqueId,
  goddessName,
  selectedMaterial
) {
  let material = selectedMaterial;
  if (!material) {
    const materialInput = document.getElementById(uniqueId + "_material");
    if (materialInput) {
      material = materialInput.value;
    } else {
      // Fallback for safety
      material = "14K Gold Vermeil";
    }
  } else {
    // Update the hidden input if a material was selected via click
    const materialInput = document.getElementById(uniqueId + "_material");
    if (materialInput) materialInput.value = material;
  }

  const length = document.getElementById(uniqueId + "_length").value;
  const product = UNIFIED_GODDESS_DATA.product;

  let variant = product.variants.find(
    (v) =>
      v.option2 === goddessName &&
      v.option1 === material &&
      v.option3 === length
  );

  if (!variant) {
    // Fallback if exact combination doesn't exist (unlikely with this data set)
    variant = product.variants.find(
      (v) => v.option2 === goddessName && v.option1 === material
    );
  }

  if (variant) {
    const imageObj = product.images.find((img) => img.id === variant.image_id);
    // For the product image at the bottom, we ALWAYS want the variant image (Gold/Silver), NOT the avatar
    const imageUrl = imageObj
      ? imageObj.src
      : product.images[0]
      ? product.images[0].src
      : "";

    const imgEl = document.getElementById(uniqueId + "_image");
    if (imgEl) imgEl.src = imageUrl;

    const priceEl = document.getElementById(uniqueId + "_price");
    if (priceEl) {
      priceEl.innerText = `$${variant.price}`;
    }

    const variantInput = document.getElementById(uniqueId + "_variant");
    if (variantInput) {
      variantInput.value = variant.id;
    }
  }
};

async function addVariantToCart(variantId, buttonEl) {
  if (!variantId) {
    throw new Error("Missing variant id");
  }

  const button = buttonEl || null;
  const originalText = button ? button.innerText : "";

  if (button) {
    button.innerText = "ADDING...";
  }

  // Shopify's /cart/add.js accepts variant IDs as either numbers or strings.
  // We keep it as a string to avoid JavaScript precision issues with large IDs.
  const idToSend = String(variantId);

  const response = await fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    credentials: "same-origin",
    body: JSON.stringify({
      items: [
        {
          id: idToSend,
          quantity: 1,
        },
      ],
    }),
  });

  if (!response.ok) {
    let errorMessage = response.statusText || "Unknown error";
    try {
      const errorBody = await response.json();
      console.error("Shopify cart error response:", errorBody);
      if (errorBody) {
        // Shopify can return errors in different formats
        errorMessage =
          errorBody.description ||
          errorBody.message ||
          errorBody.error ||
          JSON.stringify(errorBody);
      }
    } catch (e) {
      // ignore json parse errors
      console.error("Could not parse error response:", e);
    }

    if (button) {
      button.innerText = originalText || "ADD TO CART";
    }

    console.error(
      "Add to cart failed. Variant ID:",
      idToSend,
      "Status:",
      response.status,
      "Error:",
      errorMessage
    );
    throw new Error(errorMessage);
  }

  if (button) {
    button.innerText = "ADDED!";
    setTimeout(() => {
      button.innerText = originalText || "ADD TO CART";
    }, 2000);
  }

  document.dispatchEvent(new CustomEvent("cart:updated"));
}

window.addUnifiedGoddessToCart = async function (uniqueId) {
  const variantInput = document.getElementById(uniqueId + "_variant");
  const ctaEl = document.getElementById(uniqueId + "_cta");

  if (!variantInput || !variantInput.value) {
    console.error("Cannot add to cart: variant input missing for", uniqueId);
    alert("Please select your preferred options first.");
    return;
  }

  try {
    await addVariantToCart(variantInput.value, ctaEl);
  } catch (error) {
    console.error("Error adding unified goddess product to cart:", error);
    alert(
      error.message ||
        "Sorry, we couldn't add that to your cart. Please try again."
    );
  }
};

window.addToCart = async function (productId) {
  try {
    console.log("addToCart called with productId:", productId);
    const variantInput = document.getElementById(productId + "_variant");
    console.log("Variant input element:", variantInput);
    console.log(
      "Variant input value:",
      variantInput ? variantInput.value : "NOT FOUND"
    );

    if (!variantInput || !variantInput.value) {
      console.error("Variant input missing or empty for product:", productId);
      alert(
        "Please select your preferred options before adding this to your cart."
      );
      return;
    }

    await addVariantToCart(variantInput.value);
  } catch (error) {
    console.error("Error adding to cart:", error);
    alert(
      error.message ||
        "Sorry, we couldn't add that to your cart. Please try again."
    );
  }
};

function processProductIds(e) {
  let a = 0;
  for (let r in e)
    if (e.hasOwnProperty(r)) {
      e[r].forEach((e, i) => {
        if (r === "Mythological") {
          a += 1;
          if (a === 1) {
            insertHardcodedGoddessProduct(e, "outer_goddess_product");
          } else if (a === 2) {
            insertHardcodedGoddessProduct(e, "inner_goddess_product");
          }
        } else if (r === "IRL") {
          // For IRL category, we now also use the Unified Product if that is the intention,
          // but based on the provided data, IRL figures like Joan of Arc are NOT in the unified product variants.
          // However, the user request implies "your outer goddess, your inner goddess, and your IRL godess" should use the unified product.
          // Assuming the user might have meant the *placements* should use the Unified Product logic if applicable.
          // If the user insists "Unified product... go into... IRL goddess", but "Joan of Arc" isn't in the variants,
          // we have a data mismatch.
          // BUT, the user said "you know the unified product is supposed to have a different godess variant go into each..."
          // This might mean they expect the result for "IRL" to be mapped to one of the unified variants, OR
          // they provided data that *should* have included IRL figures but didn't?
          // OR, more likely, for the purpose of this fix, they want the logic to support placement into the IRL slot.
          // If 'e' (the result) matches a variant in Unified Product, we use it.

          // Let's check if 'e' is in the Unified Product variants.
          const product = UNIFIED_GODDESS_DATA.product;
          const isUnifiedVariant = product.variants.some(
            (v) => v.option2 === e
          );

          if (isUnifiedVariant) {
            insertHardcodedGoddessProduct(e, "IRL_goddess_product");
          } else {
            // Fallback to old logic if not in unified product (e.g. Joan of Arc)
            // BUT the old logic is failing with 404s.
            // The user might be expecting us to FIX the 404s by replacing it with the Unified Product logic IF possible.
            // If 'e' is JoanOfArc, and it's not in Unified, we can't force it unless we map JoanOfArc to a variant.
            // For now, I will leave the old logic for non-matching IRLs but log it.
            let n = productIds[r][e];
            if (n) {
              0 === i && insertFirstProduct(n, r);
            } else {
              console.error(`No ID found for product: ${e} in category: ${r}`);
            }
          }
        } else {
          let n = productIds[r][e];
          n
            ? "Mythological" == r // This block is now redundant for Mythological but kept for structure if needed
              ? ((a += 1),
                1 === a
                  ? insertFirstProduct(n, r)
                  : 2 === a && insertFirstProduct(n, r + "_2"))
              : 0 === i && insertFirstProduct(n, r)
            : console.error(`No ID found for product: ${e} in category: ${r}`);
        }
      });
    }
}
function selectInitialProduct(e) {
  let a,
    r,
    i = "7565323042868",
    n = "https://aweinspired.com/products/initial-necklace-14k-gold-vermeil";
  switch (e.charAt(0).toLowerCase()) {
    case "a":
      (a = "A Amulet"), (r = "A");
      break;
    case "b":
      (a = "B Amulet"), (r = "B");
      break;
    case "c":
      (a = "C Amulet"), (r = "C");
      break;
    case "d":
      (a = "D Amulet"), (r = "D");
      break;
    case "e":
      (a = "E Amulet"), (r = "E");
      break;
    case "f":
      (a = "F Amulet"), (r = "F");
      break;
    case "g":
      (a = "G Amulet"), (r = "G");
      break;
    case "h":
      (a = "H Amulet"), (r = "H");
      break;
    case "i":
      (a = "I Amulet"), (r = "I");
      break;
    case "j":
      (a = "J Amulet"), (r = "J");
      break;
    case "k":
      (a = "K Amulet"), (r = "K");
      break;
    case "l":
      (a = "L Amulet"), (r = "L");
      break;
    case "m":
      (a = "M Amulet"), (r = "M");
      break;
    case "n":
      (a = "N Amulet"), (r = "N");
      break;
    case "o":
      (a = "O Amulet"), (r = "O");
      break;
    case "p":
      (a = "P Amulet"), (r = "P");
      break;
    case "q":
      (a = "Q Amulet"), (r = "Q");
      break;
    case "r":
      (a = "R Amulet"), (r = "R");
      break;
    case "s":
      (a = "S Amulet"), (r = "S");
      break;
    case "t":
      (a = "T Amulet"), (r = "T");
      break;
    case "u":
      (a = "U Amulet"), (r = "U");
      break;
    case "v":
      (a = "V Amulet"), (r = "V");
      break;
    case "w":
      (a = "W Amulet"), (r = "W");
      break;
    case "x":
      (a = "X Amulet"), (r = "X");
      break;
    case "y":
      (a = "Y Amulet"), (r = "Y");
      break;
    case "z":
      (a = "Z Amulet"), (r = "Z");
      break;
    default:
      (a = "Default Amulet"), (r = "Default");
  }
  (sectionHtml = `\n                      <input type="hidden" id="${i}_url" value="${n}">\n                      <input type="hidden" id="${i}_material" value="14K Yellow Gold Vermeil"></input>\n                      <input type="hidden" id="${i}_variant" value="">\n                      <div class="initial__cards_col_title all-text-white">\n                            <h2>INITIAL</h2>\n                        </div>\n                        <div class="initial__cards_col_inner">\n                            <div class="initial__cards_col_inner_prod">\n                                <div class="initial__cards_col_inner_prod_content">\n                                   <div class="initial__cards_col_inner_prod_content_img">\n                                        <img id="${i}_image" src="" alt="${a}" loading="lazy">\n                                    </div>\n                                    <div class="initial__cards_col_inner_prod_content_info all-text-white">\n                                        <div class="initial__cards_col_inner_prod_content_info_tag">\n                                            <a href="${n}" target="_blank">${a}</a>\n                                            <p style="display:none;"></p>\n                                        </div>\n                                        <div class="initial__cards_col_inner_prod_content_info_price">\n                                            <p id="${i}_price">200.00</p>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                            <div class="initial__cards_col_inner_nav" style="display:none;">\n                                <ul class="tabnav initnav" data-product-id="${i}">\n                                    <li><a href="#tab1-3" class="tab3" data-material="14K Yellow Gold Vermeil" onclick="updateProductDetailsFromTab(this)"></a></li>\n                                    <li><a href="#tab1-4" class="tab4" data-material="Sterling Silver" onclick="updateProductDetailsFromTab(this)"></a></li>\n                                 </ul>\n                            </div>\n                            <div style="position:absolute;bottom:105px;right:0px;">\n                              <label style="display:none;" for="chain-type">Chain Type:</label>\n                              <select id="${i}_chain_type" class="dropdown" onchange="updateProductDetails('${i}')">\n                                <option value="16-18&quot; Box Chain">16"-18" Box Chain</option>\n                                <option value="20-22&quot; Box Chain">20"-22" Box Chain</option>\n                              </select>\n                            </div>\n                            <div style="position:absolute;bottom:109px;right:0px;display:none;">\n                              <select id="${i}_third_option" class="dropdown" onchange="updateProductDetails('${i}')">\n                                <option value="${r}">${r}</option>\n                              </select>\n                          </div>\n                            <div class="initial__cards_col_inner_cta">\n                                <span onclick="addToCart('${i}')" class="button1">ADD TO CART</span>\n                            </div>\n                        </div>\n                        <div class="initial__cards_col_button">\n                            <a href="https://aweinspired.com/collections/affirmations" target="_blank" class="btn btn--no-min-width btn--ghost">SHOP ALL AFFIRMATION</a>\n                        </div>        \n        `),
    (document.getElementById("initial_goddess_product").innerHTML =
      sectionHtml),
    fetchProductData(i);
}
function charityPlacement(e) {
  let a = "",
    r = "",
    i = "";
  "Gay, Lesbian, and Straight Education Network" === e.octane_personal_charity
    ? ((a = "https://aweinspired.com/cdn/shop/t/416/assets/glsen-charity.png"),
      (r = "Gay, Lesbian, and Straight Education Network"),
      (i =
        "Fund one year of resources for a student-led gender and sexuality alliance club with GLSEN, a foundation that works to ensure LGBTQ students can learn and grow free from bullying in schools."),
      (url = ""))
    : "Women's Earth Alliance" === e.octane_personal_charity
    ? ((a = "https://aweinspired.com/cdn/shop/t/416/assets/wea-charity.png"),
      (r = "Women's Earth Alliance"),
      (i =
        "Fund training for 20 women to grow and maintain 1,250 trees with the WEA, a foundation that catalyzes women-led, grassroots solutions to protect our environment and strengthen communities."),
      (url = ""))
    : "Rape, Abuse & Incest National Network" === e.octane_personal_charity
    ? ((a = "https://aweinspired.com/cdn/shop/t/416/assets/rainn-charity.png"),
      (r = "Rape, Abuse & Incest National Network"),
      (i =
        "Fund support for trauma-informed crisis intervention for sexual violence survivors with RAINN, the nation's largest anti-sexual violence organization. "),
      (url = ""))
    : "The National Alliance on Mental Illness" === e.octane_personal_charity &&
      ((a = "https://aweinspired.com/cdn/shop/t/416/assets/nami-charity.png"),
      (r = "The National Alliance on Mental Illness"),
      (i =
        "Fund the training of 3 volunteers operating a mental health helpline with NAMI, the nation’s largest grassroots mental health organization."),
      (url = "")),
    (sectionHtml = `\n    <div class="charity__details_logo">\n                        <img src="${a}" alt="${r}" loading="lazy">\n                    </div>\n                    <div class="charity__details_content all-text-black">\n                        <h2 id="charityName">${r}</h2>\n                        <p>${i}</p>\n                        <div class="charity__details_content_button">\n                            <a href="https://aweinspired.com/pages/charities" target="_blank" class="btn btn--no-min-width btn--ghost">LEARN MORE</a>\n                        </div>\n                    </div>\n  `),
    (document.getElementById("charity-details").innerHTML = sectionHtml);
}
function testQuizLogic(e) {
  let a = getQuizResults(e);
  processProductIds(JSON.parse(a)),
    charityPlacement(e),
    e.octane_first_name
      ? ((document.getElementById("octane_first_name").innerText =
          e.octane_first_name + "'s"),
        selectInitialProduct(e.octane_first_name))
      : ((document.getElementById("octane_first_name").innerText = "Your"),
        (document.getElementById("initial_goddess_product").style.display =
          "none"));
}
